import React, { useEffect, useState } from "react";
import styles from "./NewUiSinglePackage.module.scss";
import NewFooterUI from "../../NewFooterUI/NewFooterUI";
import NewUiHeader from "../../NewUIHeader/NewUIHeader";
import {
  CrossWithBorder,
  SvgAccordion,
  SvgCamera,
  SvgClock,
  SvgDownload,
  SvgEmail,
  SvgLocation,
  SvgPrint,
  SvgWhatsapp,
} from "../../../../utils/svgIcons";
import NewUiSinglePackageAccommodation from "./NewUiSinglePackageAccommodation";
import {
  formatIndianCurrency,
  scrollToTop,
  currentDateSingle,
  calculateLOS,
  textDateFormatter,
} from "../../../../utils/utils";
import SendItinerary from "../../../SendItinerary/SendItinerary";
import ChooseUs from "../../../ChooseUs/ChooseUs";
import OurQuery from "../../../OurQuery/OurQuery";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { Fancybox } from "@fancyapps/ui";
import imgNotFound from "../../../../assets/images//single-image.png";
import PackageQueryForm from "../../../NewSendEnquiryPopup/PackageQueryForm";
import PackageDetails from "../../../ButtonToDownload/PackageDetails";
import NewShare from "../../NewShareMailPrint/NewShare";
import NewMail from "../../NewShareMailPrint/NewMail";
import NewPrint from "../../NewShareMailPrint/NewPrint/NewPrint";
import SinglePackageHeader from "../../../SinglePackageHeader/SinglePackageHeader";
import Skeleton from "react-loading-skeleton";
import PageMetaData from "../../../PageMetaData/PageMetaData";
import OgMetaTitles from "../../../PageMetaData/OgMetaTitles";
import EditNewUiSearchFormHolidays from "../../NewUiSearchForm/NewUiSearchFormHolidays/EditNewUiSearchFormHolidays";
import EditNewUiSinglePackageSearchFormHolidays from "../../NewUiSearchForm/NewUiSearchFormHolidays/EditNewUiSinglePackageSearchFormHolidays";
import NewCustomSliderTaxi from "../../../CustomSliderTaxi/NewCustomSliderTaxi";
import NewUICustomSliderForSinglePackage from "../../../CustomSliderTaxi/NewUICustomSliderForSinglePackage";
import NewDownloadPdfButton from "../../../ButtonToDownload/NewDownloadPdfButton";
import NewPackageDownloadPdf from "../../../ButtonToDownload/NewPackageDownloadPdf";
import NewUIPackagePrint from "../../NewShareMailPrint/NewPrint/NewUIPackagePrint";

const NewUiSinglePackage = () => {
  // All Hooks
  const userType = localStorage.getItem("userType");
  const userToken = localStorage.getItem("token");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));
  const navigate = useNavigate();
  const { packageHandle } = useParams();
  // All Hooks End

  // All States
  const [loader, setLoader] = useState(false);
  const [showChildBreakUpPopup, setShowChildBreakUpPopup] = useState(false);
  const [singlePackage, setSinglePackage] = useState({});
  const [allDestinations, setAllDestinations] = useState([]);
  const [filter, setFilter] = useState("detailed_itinerary");
  const [detailedFilter, setDetailedFilter] = useState("overview");
  const [openIndex, setOpenIndex] = useState(0);
  const [openOuterAccordion, setOpenOuterAccordion] = useState([
    "detailed_itinerary",
  ]);

  // Accommodation States
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [ratesOfPackages, setRatesOfPackages] = useState(null);
  const [allPackageHotels, setAllPackageHotels] = useState([]);
  const [packageRates, setPackageRates] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [commission, setCommission] = useState({});
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [markupData, setMarkupData] = useState([]);
  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [activePayment, setActivePayment] = useState("priceSummary");
  const [selectedHotelId, setSelectedHotelId] = useState(null);
  const [promotions, setPromotions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [date, setDate] = useState({
    setDay: "",
    setMonth: "",
    setYear: "",
  });
  const [guest, setGuest] = useState(2);
  const [data, setData] = useState(null);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  const [newChildAge, setNewChildAge] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [showRatePopup, setshowRatePopup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);
  const [packageId, setPackageId] = useState(null);
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [allVehicles, setAllVehicles] = useState([]);
  const [showVehicleSlider, setShowVehicleSlider] = useState(false);
  const [customizableRatesLoader, setCustomizableRatesLoader] = useState(false);
  const [oldVehicleCost, setOldVehicleCost] = useState(0);
  const [newVehicleCost, setNewVehicleCost] = useState(0);

  // All States End
  // All Api Call
  // const getSinglePackage = async (slug) => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //   myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/single/${packageHandle}`,
  //       requestOptions
  //     );
  //     const data = await response.json();
  //     setSinglePackage(data?.data);
  //     {
  //       data?.data?.additionalDetails?.featured_category
  //         ? setSelectedCategory(
  //             data?.data?.additionalDetails?.featured_category
  //           )
  //         : setSelectedCategory(data?.data?.hotelCategory[0]);
  //     }
  //     {
  //       data?.data?.additionalDetails?.featured_meal_plan &&
  //         setSelectedMealPlan(
  //           data?.data?.additionalDetails?.featured_meal_plan
  //         );

  //       // setSelectedMealPlan(packageRates[0]?.mealPlan);
  //     }

  //     const allAccommodations = data?.data?.packageItinerary.flatMap(
  //       (item) => item.accommodation
  //     );

  //     if (allAccommodations) {
  //       const uniqueAccommodations = Array.from(
  //         new Map(
  //           allAccommodations?.map((hotel) => [hotel?.accommodationId, hotel])
  //         ).values()
  //       );
  //       setAllPackageHotels(uniqueAccommodations);
  //     }

  //     setPackageRates(data?.data?.packageRates);
  //     scrollToTop();
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };
  // All Api Call End

  // All Functions

  const calculateNights = (data) => {
    let destinations = [];
    let currentDestination = null;
    let nights = 0;

    if (data) {
      for (let i = 0; i < data.length; i++) {
        const { startDestination, endDestination } = data[i];

        // Ignore the first transit destination (like "Chandigarh")
        if (i === 0) continue;

        if (currentDestination === startDestination) {
          nights++; // Continue counting nights
        } else {
          if (currentDestination) {
            destinations.push({
              destination: currentDestination,
              night: nights,
            });
          }
          currentDestination = startDestination;
          nights = 1; // Start new night count
        }
      }
    }

    // Push the last counted destination
    if (currentDestination) {
      destinations.push({ destination: currentDestination, night: nights });
    }

    return destinations;
  };

  useEffect(() => {
    if (singlePackage) {
      const destinationData = calculateNights(singlePackage?.packageItinerary);
      setAllDestinations(destinationData);
      const currentDate = new Date();
      const packageStartDate = new Date(singlePackage?.validFrom);
      const packageEndDate = new Date(singlePackage?.validTo);

      if (currentDate < packageStartDate || currentDate > packageEndDate) {
        setIsExpired(true);
      }
    }
  }, [singlePackage]);

  // Filter Scroll Section
  // const handleScrollToSection = (sectionValue) => {
  //   setFilter(sectionValue);
  //   document
  //     .getElementById(sectionValue)
  //     ?.scrollIntoView({ behavior: "smooth" });
  // };

  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    const section = document.getElementById(sectionValue);
    if (section) {
      const headerHeight =
        document.querySelector("#NewUIHeader")?.offsetHeight || 0;
      const searchFormHeight =
        document.querySelector("#HotelEditSearchForm")?.offsetHeight || 0;
      const totalOffset = headerHeight + searchFormHeight + 110; // Adding extra spacing
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - totalOffset,
        behavior: "smooth",
      });
    }

    setOpenOuterAccordion((prev) => {
      if (prev.includes(sectionValue)) {
        return prev.filter((item) => item !== sectionValue);
      } else {
        return [...prev, sectionValue];
      }
    });

    setShowAllTabs(false);
  };

  useEffect(() => {
    const sections = document.querySelectorAll(".scroll-section");

    const observer = new IntersectionObserver(
      (entries) => {
        let visibleSection = filter; // Preserve the current filter if no section is in view
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleSection = entry.target.id;
          }
        });
        setFilter(visibleSection);
      },
      { threshold: 0.3 } // Change threshold to 30% visibility
    );

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);
  // Filter Scroll Section End

  const handleDetailedFilter = (value) => {
    setDetailedFilter(value);
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // All Functions End

  // Custom Arrays
  const detailedItinerary = [
    { label: "Overview", value: "overview" },
    // {
    //   label: singlePackage.totalDays + " " + "Days Itinerary",
    //   value: "itinerary",
    // },
    { label: "Accommodation", value: "accommodation" },
    // { label: "Gallery", value: "gallery" },
  ];

  const mainFilters = [
    { label: "Detailed Itinerary", value: "detailed_itinerary" },
    { label: "Stays", value: "stays" },
    { label: "Inclusions & Exclusions", value: "inclusion_exclusion" },
    { label: "Things to Know", value: "points_to_remember" },
    { label: "Terms & Conditions", value: "terms_and_conditions" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
  ];
  const [activeFilter, setActiveFilter] = useState("detailed_itinerary");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };

  // Accommodation Code
  // markup fetch api
  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );

          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const handleSelectedAddOns = (addon) => {
    setSelectedAddOns((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === addon.id
      );
      if (isSelected) {
        return prevSelected.filter((selected) => selected.id !== addon.id);
      } else {
        return [...prevSelected, addon];
      }
    });
  };

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  const togglePaymentDetails = () => {
    setPaymentDetails(!paymentDetails);
  };

  const handleButtonClick = () => {
    setActivePayment((prev) =>
      prev === "priceSummary" ? "priceDetails" : "priceSummary"
    );
  };

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const storedData = JSON.parse(localStorage.getItem("selected"));

  const agentDetails = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    if (storedData) {
      setData(selectedHotelId);
    }
  }, [localStorage]);

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const [activeTab, setActiveTab] = useState("package-information");

  const handleshowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(!showRatePopup);
  };

  const postQueryData = () => { };

  const location = useLocation();

  const commissionAmount = commission?.commissionAmount;
  const commissionType = commission?.commissionType;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    const newChildAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    i = 1;
    while (params.has(`childAge[${i}]`)) {
      const age = parseInt(params.get(`childAge[${i}]`), 10);
      newChildAges.push({
        age: age.toString(),
        type: age < 6 ? "complimentary" : "withbed",
      });
      i++;
    }

    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest") || 2,
      children: params.get("children"),
      departureDay: params.get("checkinDay"),
      departureMonth: params.get("checkinMonth"),
      departureYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      newChildAge: newChildAges,
      date: params.get("date"),
      day: params.get("day"),
      month: params.get("month"),
      year: params.get("year"),
      packageId: params.get("packageId"),
      packageHandle: packageHandle,
    };

    setDate({
      setDay: data.day,
      setMonth: data.month,
      setYear: data.year,
    });

    setPackageId(data.packageId);

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    setLoader(true);

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/single/${packageHandle}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setSinglePackage(data?.data);
        {
          data?.data?.additionalDetails?.featured_category
            ? setSelectedCategory(
              data?.data?.additionalDetails?.featured_category
            )
            : setSelectedCategory(data?.data?.hotelCategory[0]);
        }
        {
          data?.data?.additionalDetails?.featured_meal_plan &&
            setSelectedMealPlan(
              data?.data?.additionalDetails?.featured_meal_plan
            );
        }

        const allAccommodations = data?.data?.packageItinerary.flatMap(
          (item) => item.accommodation
        );

        if (allAccommodations) {
          const uniqueAccommodations = Array.from(
            new Map(
              allAccommodations?.map((hotel) => [hotel?.accommodationId, hotel])
            ).values()
          );
          setAllPackageHotels(uniqueAccommodations);
        }

        setPackageRates(data?.data?.packageRates);
        scrollToTop();
        setLoader(false);
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );

    let checkInDate = currentDateSingle;

    if (data.year && data.month && data.day) {
      checkInDate = `${data.year}-${String(data.month).padStart(
        2,
        "0"
      )}-${String(data.day).padStart(2, "0")}`;
    }

    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setData({
      fromCity: params.get("location"),
    });

    setGuest(data.guest);
    setChildren(data.children);
    setRooms(data.room);
    setChildAge(childAges);
    setNewChildAge(newChildAges);

    if (data.day && data.month && data.year) {
      setStartDate(checkInDate);
    } else {
      setStartDate(currentDateSingle);
    }
    // setStartDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData(data);

    fetchPromotions({
      checkInDateFromBooking: checkInDate,
      packageIdFromBooking: Number(data?.packageId),
    });
  }, [location.search]);

  const handleTypeChange = (index) => {
    setNewChildAge((prev) =>
      prev.map((item, i) =>
        i === index && item.age >= 6
          ? {
            ...item,
            type: item.type === "withbed" ? "withoutbed" : "withbed",
          }
          : item
      )
    );
  };

  const totalAddonsCostWithoutCommission = selectedAddOns?.reduce(
    (total, addon) => {
      if (addon.priceWithMarkup) {
        if (addon.perPerson && guest) {
          return total + Number(addon.priceWithMarkup) * Number(guest);
        } else {
          return total + Number(addon.priceWithMarkup);
        }
      }
    },
    0
  );

  const totalAddonsCost = selectedAddOns?.reduce((total, addon) => {
    if (addon.perPerson && guest) {
      return total + Number(addon.finalAddonPrice) * Number(guest);
    } else {
      return total + Number(addon.finalAddonPrice);
    }
  }, 0);

  const fetchTransportCost = (vehicle) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const titles = singlePackage?.packageDestination?.map(
      (destination) => destination?.name
    );

    // Create FormData
    const formdata = new FormData();

    // Log the FormData object for verification
    // console.log([...formdata.entries()]);

    // const formdata = new FormData();
    formdata.append("hub", singlePackage?.packageHub);
    formdata.append("days", singlePackage?.totalDays);
    formdata.append("nights", singlePackage?.totalNights);
    formdata.append("vehicle_type", vehicle);
    formdata.append("destinations[]", JSON.stringify(titles));
    // formdata.append("capacity", guest);

    // formdata.append("hub", "Ex-Chandigarh");
    // formdata.append("days", "6");
    // formdata.append("nights", "5");
    // formdata.append("vehicle_type", vehicle);
    // formdata.append("destinations[]", '["Narkanda","Jibhi","Tirthan","Kasol"]');
    // formdata.append("capacity", "4");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/transport-fixed-rates/fetch`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        // setVehicleDetails(result?.data);
      })
      .catch((error) => console.error(error));
  };

  const fetchCostOfVehicle = (vehicle) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const titles = singlePackage?.packageDestination?.map(
      (destination) => destination.title
    );

    // Create FormData
    const formdata = new FormData();

    // Log the FormData object for verification

    // const formdata = new FormData();
    formdata.append("hub", singlePackage?.packageHub);
    formdata.append("days", singlePackage.totalDays);
    formdata.append("nights", singlePackage.totalNights);
    formdata.append("vehicle_type", vehicle);
    formdata.append("destinations", JSON.stringify(titles));
    formdata.append("capacity", guest);

    // formdata.append("hub", "Ex-Chandigarh");
    // formdata.append("days", "9");
    // formdata.append("nights", "8");
    // formdata.append("vehicle_type", "Sedan");
    // formdata.append("destinations", ["Shimla","Dalhousie","Dharamshala","Manali"]);
    // formdata.append("capacity", "1");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/v1/transport-fixed-rates/fetch`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.data[0]?.Price) {
          setOldVehicleCost(Number(result?.data[0]?.Price));
        }
      })
      .catch((error) => console.error(error));
  };

  const [priceLoader, setPriceLoader] = useState(false);

  const getRatesFromApi = async (
    packageId,
    pax,
    selectedCategory,
    selectedMealPlan
  ) => {
    // console.log(
    //   packageId,
    //   pax,
    //   selectedCategory,
    //   selectedMealPlan,
    //   "getRatesFromApi"
    // );
    setPriceLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    // children older than 6
    // const childrenAbove6 = childAge?.filter((age) => age > 6).length || 0;
    // const no_pax = Number(guest) + Number(childrenAbove6);

    const formdata = new FormData();
    formdata.append("package_id", packageId);
    formdata.append("no_pax", pax == 1 ? 2 : pax);
    // formdata.append("no_pax", no_pax);
    formdata.append("hotelCategory", selectedCategory);
    formdata.append("mealPlan", selectedMealPlan ? selectedMealPlan : "na");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const MIN_LOADING_TIME = 800;

    try {
      const startTime = Date.now();

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/rate`,
        requestOptions
      );
      const result = await response.json();
      setRatesOfPackages(result?.data);
      fetchTransportCost(result?.data?.VehicleType);

      const timeElapsed = Date.now() - startTime;
      const remainingTime = MIN_LOADING_TIME - timeElapsed;

      if (remainingTime > 0) {
        setTimeout(() => setPriceLoader(false), remainingTime);
      } else {
        setPriceLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setPriceLoader(false);
    }
  };
  // console.log(
  //   singlePackage?.packageId,
  //   bookingData?.guest,
  //   selectedCategory,
  //   selectedMealPlan,
  //   "asdas"
  // );

  useEffect(() => {
    if (
      singlePackage?.packageId &&
      bookingData?.guest &&
      selectedCategory &&
      selectedMealPlan
    ) {
      getRatesFromApi(
        singlePackage?.packageId,
        bookingData?.guest,
        selectedCategory,
        selectedMealPlan
      );
    }
  }, [singlePackage, bookingData?.guest, selectedCategory, selectedMealPlan]);

  const childWithAgeLessThanSix = bookingData?.childAge?.filter(
    (age) => age < 6
  )?.length;

  // reusable fn
  function calculateFinalPrice(basePrice, markupData, commissionData) {
    let finalPrice = 0;
    let priceAfterMarkup = 0;

    if (!basePrice || typeof basePrice !== "number" || basePrice <= 0) {
      return;
    }

    finalPrice = basePrice;

    // Apply Markup
    if (markupData?.markupType && markupData?.amount) {
      if (markupData.markupType === "percentage") {
        finalPrice += (basePrice * markupData.amount) / 100;
      } else if (markupData.markupType === "fixed") {
        finalPrice += Number(markupData.amount);
      }
    }
    priceAfterMarkup = finalPrice;

    // Apply Commission
    // if (commissionData?.commissionType && commissionData?.commissionAmount) {
    //   if (commissionData.commissionType === "percentage") {
    //     finalPrice -= (finalPrice * commissionData.commissionAmount) / 100;
    //   } else if (commissionData.commissionType === "fixed") {
    //     finalPrice -= Number(commissionData.commissionAmount);
    //   }
    // }

    return { finalPrice, priceAfterMarkup };
  }

  function calculateTotalAmount(
    basePrice = 0,
    selectedAutomaticDiscount,
    selectedDiscount,
    guest = 2,
    ratesOfPackages,
    childAgeArray,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType,
    newChildAge
  ) {
    const childWithAgeGreaterThanSix = childAgeArray.filter(
      (age) => age > 6
    )?.length;
    const childWithAgeLessThanSix = childAgeArray.filter(
      (age) => age < 6
    )?.length;

    const perPaxCount =
      Number(bookingData.guest) +
      childAgeArray?.length +
      ratesOfPackages?.ExtraAdultCount;

    guest = Number(guest);

    // discount = Number(discount);

    let startingPrice = basePrice;
    let markupAmount;
    let commissionAmt;

    if (markupData?.markupType) {
      if (markupData?.markupType === "percentage") {
        markupAmount = (basePrice * markupData?.amount) / 100;
      } else {
        markupAmount = Number(markupData?.amount);
      }
    }

    let onlyAdultCost = 0;

    if (markupAmount && basePrice) {
      basePrice = Number(basePrice) + markupAmount;
    }

    const preCommissionPrice = basePrice;

    const postCommissionPrice = basePrice;

    const agentSavings = preCommissionPrice - postCommissionPrice;

    onlyAdultCost = basePrice * guest;
    basePrice = basePrice * guest;

    let adjustedPackagePrice = startingPrice;

    let adultCosts = 0;
    let extraAdultSavings = 0;

    if (ratesOfPackages?.ExtraAdultCount) {
      adultCosts =
        Number(ratesOfPackages?.ExtraAdultCount) *
        Number(ratesOfPackages?.ExtraAdult);

      // const preExtraAdultPrice = adultCosts;
      let extraAdultMarkuoAmount;
      let extraAdultCommissionAmount;

      if (markupData?.markupType) {
        if (markupData?.markupType === "percentage") {
          extraAdultMarkuoAmount = (adultCosts * markupData?.amount) / 100;
        } else {
          extraAdultMarkuoAmount = Number(markupData?.amount);
        }
      }

      if (adultCosts && extraAdultMarkuoAmount) {
        adultCosts += extraAdultMarkuoAmount;
      }

      const preExtraAdultPostMarkup = adultCosts;

      // if (commissionAmount && commissionType) {
      //   if (commissionType === "percentage") {
      //     extraAdultCommissionAmount =
      //       (Number(adultCosts) * Number(commissionAmount)) / 100;
      //   } else if (commissionType === "fixed") {
      //     extraAdultCommissionAmount = Number(commissionAmount);
      //   }
      // }

      // if (adultCosts && extraAdultCommissionAmount) {
      //   adultCosts -= extraAdultCommissionAmount
      // }

      basePrice = basePrice + adultCosts;
      const postExtraAdultPrice = adultCosts;

      extraAdultSavings = preExtraAdultPostMarkup - postExtraAdultPrice;
    }

    let childCosts = 0;
    let childCostWithBed = 0;
    let childCostWithOutBed = 0;
    let childSavingsWithBed = 0;
    let childSavingsWithoutBed = 0;

    // if (childAgeArray?.length > 0) {
    //   childAgeArray.forEach((age) => {
    //     if (Number(age) >= 6) {
    //       // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithBedCost,
    //         markupData,
    //         commission
    //       );

    //       childCostWithBed += Number(result?.finalPrice);
    //       // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //     } else {
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithOutBedCost,
    //         markupData,
    //         commission
    //       );

    //       if (volvoAddonPrice !== undefined) {
    //         const volvoCost =
    //           +volvoAddonPrice / Number(childWithAgeLessThanSix);
    //         childCostWithOutBed +=
    //           Number(result?.finalPrice) + result?.volvoCost;
    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       } else {
    //         childCostWithOutBed += Number(result?.finalPrice);
    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       }
    //     }
    //   });
    // }

    // if (childAgeArray?.length > 0) {
    //   childAgeArray.forEach((age) => {
    //     if (Number(age) >= 6) {
    //       // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithBedCost,
    //         markupData,
    //         commission
    //       );

    //       childCostWithBed += Number(result?.finalPrice);
    //       // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //     } else if (Number(age) < 6) {
    //       const result = calculateFinalPrice(
    //         ratesOfPackages?.ChildWithOutBedCost,
    //         markupData,
    //         commission
    //       );

    //       if (volvoAddonPrice !== undefined) {
    //         const volvoCost =
    //           +volvoAddonPrice / Number(childWithAgeLessThanSix);
    //         // childCostWithOutBed += Number(result?.finalPrice) + result?.volvoCost;
    //         // const volvoCost = +volvoAddonPrice;
    //         childCostWithOutBed += volvoCost;

    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       } else {
    //         childCostWithOutBed += 0;
    //         // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
    //       }
    //     }
    //   });
    // }

    if (newChildAge?.length > 0) {
      newChildAge?.forEach((child) => {
        const { age, type } = child;
        if (Number(age) >= 6) {
          if (type === "withbed") {
            // Add cost for child with bed
            const result = calculateFinalPrice(
              ratesOfPackages?.ChildWithBedCost,
              markupData,
              commission
            );
            childCostWithBed += Number(result?.finalPrice);
          } else if (type === "withoutbed") {
            // Add cost for child without bed
            const result = calculateFinalPrice(
              ratesOfPackages?.ChildWithOutBedCost,
              markupData,
              commission
            );
            childCostWithBed += Number(result?.finalPrice);
          }
        } else if (Number(age) < 6) {
          if (volvoAddonPrice !== undefined) {
            const volvoCost =
              +volvoAddonPrice / Number(childWithAgeLessThanSix);
            // childCostWithOutBed += Number(result?.finalPrice) + result?.volvoCost;
            // const volvoCost = +volvoAddonPrice;
            childCostWithOutBed += volvoCost;

            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          } else {
            childCostWithOutBed += 0;
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          }
        }
      });
    }

    let totalAgentSavings =
      agentSavings * guest +
      extraAdultSavings +
      childSavingsWithBed +
      childSavingsWithoutBed;

    // if (commissionAmount && commissionType && totalAddonsCostWithoutCommission && totalAddonsCost) {
    //   totalAgentSavings += (totalAddonsCostWithoutCommission - totalAddonsCost)
    // }

    let totalChildCostPrice = childCostWithBed + childCostWithOutBed;

    if (totalChildCostPrice) {
      basePrice += totalChildCostPrice;
    }

    let discountAmount;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedAutomaticDiscount &&
        selectedAutomaticDiscount?.length > 0 &&
        selectedAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedDiscount &&
        selectedDiscount?.length > 0 &&
        selectedDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };
    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(basePrice);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(basePrice) -
      Number(
        totalBookingAutomaticDiscountAmount
          ? totalBookingAutomaticDiscountAmount
          : 0
      )
    );

    discountAmount =
      Number(totalBookingAutomaticDiscountAmount) +
      Number(totalBookingDiscountAmount);
    // if (discountType === "percentage") {
    //   discountAmount = (basePrice * discount) / 100;
    // } else {
    //   discountAmount = discount;
    // }

    const priceAfterDiscount = basePrice - discountAmount;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (priceAfterDiscount * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }

    let subtotal;
    if (calculatedCommissionAmount) {
      subtotal = priceAfterDiscount - calculatedCommissionAmount;
    } else {
      subtotal = priceAfterDiscount;
    }

    if (totalAddonsCost) {
      subtotal += totalAddonsCost;
    }

    const gst = subtotal * 0.05;

    const totalAmount = subtotal + gst;

    const discountPercentage = (discountAmount / basePrice) * 100;

    return {
      basePrice: basePrice.toFixed(2),
      discount: discountAmount.toFixed(2),
      priceAfterDiscount: priceAfterDiscount.toFixed(2),
      gst: gst.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      discountPercentage: discountPercentage,
      // discountType,
      taxAmount: gst.toFixed(2),
      ExtraAdultCost: adultCosts,
      childCosts,
      childCostWithBed,
      childCostWithOutBed,
      totalChildCostPrice,
      adultNumber: guest,
      onlyAdultCost: onlyAdultCost,
      extraAdultNumber: ratesOfPackages?.ExtraAdultCount,
      extraAdultCost: adultCosts,
      childNumber: newChildAge?.length,

      perPaxCount,
      perPaxCost: (totalAmount / perPaxCount).toFixed(2),
      calculatedAgentAmount: commissionAmt * guest,
      calculatedCommissionAmount,

      agentSavings,
      extraAdultSavings,
      childSavingsWithBed,
      childSavingsWithoutBed,
      subtotal,
    };
  }

  // const handleDiscountChange = (item) => {
  //   if (selectedDiscount?.id === item?.id) {
  //     setSelectedDiscount(null);
  //   } else {
  //     setSelectedDiscount(item);
  //   }
  // };
  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  // useEffect(() => {
  //   if (promotions.length > 0) {
  //     const automaticDiscount = promotions.find(
  //       (promotions) => promotions.promotionType === "automatic"
  //     );
  //     if (automaticDiscount) {
  //       setSelectedDiscount(automaticDiscount);
  //     }
  //   }
  // }, [promotions]);

  const volvoAddonPrice = Array.isArray(singlePackage?.packageAddons)
    ? singlePackage.packageAddons
      .filter(
        (detail) =>
          detail.detail.includes("Volvo") && detail.addonType === "ticket"
      )
      .map((detail) => {
        let calculatedAddonPrice = !detail.perPerson
          ? detail.price
          : Number(detail.price) * Number(childWithAgeLessThanSix);

        if (markupData) {
          const markup = markupData;
          if (markup.markupType === "percentage") {
            calculatedAddonPrice +=
              (calculatedAddonPrice * parseFloat(markup.amount)) / 100;
          } else if (markup.markupType === "fixed") {
            calculatedAddonPrice += parseFloat(markup.amount);
          }
        }
        // if (commissionAmount && commissionType) {
        //   if (commissionType === "percentage") {
        //     calculatedAddonPrice -=
        //       (Number(calculatedAddonPrice) * Number(commissionAmount)) / 100;
        //   } else if (commissionType === "fixed") {
        //     calculatedAddonPrice -= Number(commissionAmount);
        //   }
        // }
        return calculatedAddonPrice;
      })[0]
    : null;

  const calculationsOfPackages = calculateTotalAmount(
    ratesOfPackages?.Price,
    // selectedDiscount?.promotionAmount,
    // selectedDiscount?.promotionMode,
    selectedAutomaticDiscount,
    selectedDiscount,
    // agentDetails?.agent_category_discount
    //   ? agentDetails?.agent_category_discount
    //   : 0,
    // agentDetails?.agent_discount_type
    //   ? agentDetails?.agent_discount_type
    //   : "percentage",
    ratesOfPackages?.NoPax,
    ratesOfPackages,
    bookingData?.childAge ? bookingData?.childAge : [],
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType,
    // bookingData?.newChildAge ? bookingData?.newChildAge : [],
    newChildAge ? newChildAge : []
  );

  const navigateToCheckOutPackage = () => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");
    navigate(
      `/checkout-package/${bookingData?.packageHandle}?packageId=${singlePackage?.packageId}&location=${bookingData?.location}&guest=${bookingData?.guest}&children=${bookingData?.children}${childAgeParams}&checkinDay=${date.setDay}&checkinMonth=${date.setMonth}&checkinYear=${date.setYear}`,
      {
        state: {
          packageData: singlePackage,
          bookingData: bookingData,
          selectedCategory: selectedCategory,
          calculationsOfPackages: calculationsOfPackages,
          selectedAddOns: selectedAddOns,
          customized: false,
          ratesOfPackages,
          markupData,
          selectedMealPlan: selectedMealPlan,
          allPackageHotels: allPackageHotels,
          commission: commission,
          // roomsDetails: roomsDetails,
          totalAddonsCost: totalAddonsCost,
          totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
          selectedAutomaticDiscount: selectedAutomaticDiscount,
          selectedDiscount: selectedDiscount,
        },
      }
    );
  };

  const navigateToCustomizePackage = () => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    navigate(
      `/customize-package/${bookingData?.packagehandle}?packagehandle=${bookingData?.packagehandle
      }&location=${bookingData?.location}&guest=${bookingData?.guest
      }&children=${bookingData?.children ? bookingData?.children : 0
      }${childAgeParams}&checkinDay=${date.setDay}&checkinMonth=${date.setMonth
      }&checkinYear=${date.setYear}`,
      {
        state: {
          packageData: singlePackage,
          bookingData: bookingData,
          selectedCategory: selectedCategory,
          calculationsOfPackages: calculationsOfPackages,
        },
      }
    );
  };

  const under6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) < 6
  );
  const over6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) >= 6
  );

  // console.log(under6AgeChildren, 'under6AgeChildren');
  // console.log(over6AgeChildren, 'over6AgeChildren');

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];

    // console.log(checkin, checkout, discountStart, discountEnd);

    return checkin <= discountEnd && checkout >= discountStart;
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 1);
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date();
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDate);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = los;
        valueToCompare = conditionValue;
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };
    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const fetchPromotions = async ({
    checkInDateFromBooking,
    packageIdFromBooking,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPromotions(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";

          const isValidDate = checkDates(item.startDate, item.endDate);

          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBooking,
            checkInDateFromBooking,
            item.startDate,
            item.endDate
          );

          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
                ? "agents"
                : "",
            userDetails?.id,
            item.promotionApplicable
          );

          const blackoutDates = item.promotionBlackOutDate || [];

          const isBlackout = isBlackoutDate(blackoutDates, startDate);

          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "package",
            packageIdFromBooking
          );

          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            startDate
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];

      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      setSelectedAutomaticDiscount(selectedPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/package/${packageId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (packageId && userType === "agent") {
      fetchCommissions();
    }
  }, [packageId, userType]);

  const [isExpanded, setIsExpanded] = useState(true);
  const [isExpandedAddon, setIsExpandedAddon] = useState(false);

  const toggleAccordionAddon = () => {
    setIsExpandedAddon(!isExpandedAddon);
  };

  // const toggleAccordion = () => {
  //   setIsExpanded((prevState) => !prevState);
  // };

  const mapMealPlan = {
    EP: "Room Only",
    CP: "Room with Breakfast",
    MAP: "Room with Breakfast and Dinner",
    AP: "Room with Breakfast, Lunch and Dinner",
  };

  // new
  const groupByCategory = (accommodations) => {
    if (!accommodations) return {};

    const grouped = accommodations.reduce((acc, accommodation) => {
      const category = accommodation.hotelcategory;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(accommodation);
      return acc;
    }, {});

    // Sort the categories to ensure "Deluxe" is first
    const sortedCategories = Object.keys(grouped).sort((a, b) => {
      if (a === selectedCategory) return -1; // Move "Deluxe" to the top
      if (b === selectedCategory) return 1; // Keep "Deluxe" above other categories
      return 0; // Maintain the existing order for others
    });

    // Reconstruct the grouped object with "Deluxe" first

    const newData = sortedCategories.map((category) => {
      return {
        label: category?.toUpperCase(),
        value: category,
      };
    });

    // console.log("newData", newData);
    return newData;

    // return sortedCategories.reduce((sortedAcc, category) => {
    //   sortedAcc[category] = grouped[category];
    //   return sortedAcc;
    // }, {});
  };

  useEffect(() => {
    if (!singlePackage || !selectedCategory || !allPackageHotels) {
      console.error(
        "Missing data: singlePackageData or selectedCategory is undefined."
      );
      return;
    }

    const groupedData = groupByCategory(allPackageHotels);

    if (!groupedData || !groupedData[selectedCategory]) {
      console.error(
        `Error: groupByCategory returned undefined or no data for category ${selectedCategory}.`
      );
      return;
    }

    const selectedArray = groupedData[selectedCategory];

    if (selectedArray.length === 0) {
      console.warn(
        `No data found for the selected category: ${selectedCategory}`
      );
      return;
    }

    // const findMealPlan = selectedArray[0]?.accommodationMealPlan;

    if (selectedMealPlan) {
      // setSelectedMealPlan(selectedMealPlan);
    } else {
      console.warn("No meal plan found in the selected category.");
    }
  }, [selectedCategory, singlePackage]);

  const allCategories = groupByCategory(allPackageHotels);

  const getFirstActivity = (singlePackage) => {
    if (!singlePackage || typeof singlePackage !== "object") {
      console.error("Invalid input: singlePackage must be an object");
      return null;
    }

    if (!Array.isArray(singlePackage.packageItinerary)) {
      console.error("Invalid packageItinerary: Expected an array");
      return null;
    }

    const firstActivity = singlePackage.packageItinerary.flatMap((item) => {
      if (!item || typeof item !== "object") {
        console.warn("Skipping invalid itinerary item:", item);
        return [];
      }
      return Array.isArray(item.activity) ? item.activity : [];
    });

    if (!firstActivity.length) {
      console.warn("No activities found in packageItinerary");
      return null;
    }

    const name = firstActivity[0]?.name;
    return name || "No activity name available";
  };

  // console.log(singlePackage, 'singlePackage');
  // console.log(ratesOfPackages, 'ratesOfPackages');
  // console.log(selectedCategory, 'selectedCategory');

  return (
    <>
      {/* <PageMetaData
        title={`${
          singlePackage?.packageName &&
          singlePackage?.packageName !== "" &&
          singlePackage?.packageName !== undefined &&
          singlePackage?.packageName
        } - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}
      <PageMetaData
        title={`${singlePackage?.metaData?.metaTitle
          ? singlePackage.metaData.metaTitle
          : singlePackage?.packageName || ""
          } `}
        description={
          singlePackage?.metaData?.metaDescription
            ? singlePackage.metaData.metaDescription
            : ""
        }
        keywords={
          singlePackage?.metaData?.metaKeywords
            ? singlePackage.metaData.metaKeywords
            : ""
        }
      />

      <OgMetaTitles
        title={`${
          singlePackage?.metaData?.metaTitle
            ? singlePackage.metaData.metaTitle
            : singlePackage?.packageName || ""
        }`}
        description={
          singlePackage?.metaData?.metaDescription
            ? singlePackage.metaData.metaDescription
            : ""
        }
        image={
          singlePackage?.metaData?.metaImage
            ? singlePackage.metaData.metaImage
            : ""
        }
        url={`https://www.mountainmysteries.com/package/${singlePackage?.packagehandle}?location=&guest=2&children=0&packagehandle=${singlePackage?.packagehandle}#package-information`}
      />
      <NewUiHeader />

      {/* <EditNewUiSearchFormHolidays /> */}

      <EditNewUiSinglePackageSearchFormHolidays
        packageData={singlePackage}
        setSelectedAddOns={setSelectedAddOns}
      />

      {singlePackage && (
        <>
          {/* Top Section */}
          <div className={styles.section_with_background}>
            <div className={styles.container}>
              {/* Package Main Heading */}
              <div className={styles.title_container}>
                <div>
                  {loader ? (
                    <Skeleton width={100} />
                  ) : (
                    <div className="flex flex_gap_10">
                      <div className={`${styles.days_and_night} flex`}>
                        <span className="flex align_items_center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                          >
                            <mask
                              id="mask0_6863_10201"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="14"
                              height="15"
                            >
                              <rect
                                y="0.5"
                                width="14"
                                height="14"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6863_10201)">
                              <path
                                d="M7.0585 13.0417C6.28296 13.0417 5.55568 12.8945 4.87668 12.6002C4.19759 12.306 3.60526 11.906 3.0997 11.4005C2.59415 10.8949 2.19423 10.3026 1.89993 9.62349C1.60564 8.94449 1.4585 8.21722 1.4585 7.44168C1.4585 6.32061 1.76178 5.29662 2.36835 4.3697C2.97482 3.44269 3.79518 2.76568 4.82943 2.33868C5.01348 2.2609 5.18755 2.27456 5.35166 2.37966C5.51577 2.48466 5.59861 2.63404 5.60016 2.82781C5.61212 3.63922 5.7705 4.41267 6.07529 5.14816C6.37998 5.88374 6.81841 6.53756 7.39056 7.10962C7.96261 7.68177 8.61454 8.11927 9.34633 8.42212C10.0781 8.72506 10.8497 8.88251 11.6611 8.89447C11.8766 8.89593 12.0348 8.97818 12.1357 9.14122C12.2367 9.30426 12.2483 9.48077 12.1705 9.67074C11.7315 10.6991 11.05 11.518 10.126 12.1275C9.20205 12.7369 8.17957 13.0417 7.0585 13.0417Z"
                                fill="#ECB119"
                              />
                            </g>
                          </svg>
                          {`${singlePackage?.totalNights}N`}
                        </span>
                        <span className="flex align_items_center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                          >
                            <mask
                              id="mask0_6863_10206"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="14"
                              height="15"
                            >
                              <rect
                                y="0.5"
                                width="14"
                                height="14"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6863_10206)">
                              <path
                                d="M6.99986 3.54004C6.8758 3.54004 6.77192 3.49814 6.68821 3.41434C6.6044 3.33043 6.5625 3.2265 6.5625 3.10254V1.82373C6.5625 1.69977 6.60445 1.59589 6.68836 1.51208C6.77226 1.42818 6.87619 1.38623 7.00015 1.38623C7.1242 1.38623 7.22809 1.42818 7.31179 1.51208C7.3956 1.59589 7.4375 1.69977 7.4375 1.82373V3.10254C7.4375 3.2265 7.39555 3.33043 7.31165 3.41434C7.22775 3.49814 7.12381 3.54004 6.99986 3.54004ZM9.79781 4.70219C9.71702 4.62149 9.67755 4.5215 9.6794 4.40221C9.68124 4.28292 9.72256 4.17801 9.80336 4.0875L10.6929 3.17779C10.7807 3.08728 10.885 3.04202 11.0056 3.04202C11.1263 3.04202 11.2322 3.08767 11.3235 3.17896C11.4072 3.26267 11.4491 3.3647 11.4491 3.48506C11.4491 3.60552 11.4068 3.70799 11.3222 3.79248L10.4125 4.70219C10.328 4.78677 10.2255 4.82906 10.1051 4.82906C9.98472 4.82906 9.8823 4.78677 9.79781 4.70219ZM11.3975 7.9375C11.2735 7.9375 11.1696 7.89555 11.0857 7.81165C11.0019 7.72774 10.96 7.62381 10.96 7.49986C10.96 7.3758 11.0019 7.27192 11.0857 7.18821C11.1696 7.1044 11.2735 7.0625 11.3975 7.0625H12.6763C12.8002 7.0625 12.9041 7.10445 12.9879 7.18836C13.0718 7.27226 13.1138 7.37619 13.1138 7.50015C13.1138 7.6242 13.0718 7.72808 12.9879 7.81179C12.9041 7.8956 12.8002 7.9375 12.6763 7.9375H11.3975ZM6.99986 13.6138C6.8758 13.6138 6.77192 13.5718 6.68821 13.4879C6.6044 13.4041 6.5625 13.3002 6.5625 13.1763V11.903C6.5625 11.779 6.60445 11.6752 6.68836 11.5914C6.77226 11.5075 6.87619 11.4655 7.00015 11.4655C7.1242 11.4655 7.22809 11.5075 7.31179 11.5914C7.3956 11.6752 7.4375 11.779 7.4375 11.903V13.1763C7.4375 13.3002 7.39555 13.4041 7.31165 13.4879C7.22775 13.5718 7.12381 13.6138 6.99986 13.6138ZM3.59319 4.70219L2.67779 3.80706C2.58728 3.71966 2.54202 3.61403 2.54202 3.49017C2.54202 3.3664 2.58728 3.26228 2.67779 3.17779C2.76228 3.097 2.86597 3.05661 2.98886 3.05661C3.11174 3.05661 3.21295 3.097 3.29248 3.17779L4.20788 4.09319C4.28867 4.17272 4.32906 4.27393 4.32906 4.39681C4.32906 4.5197 4.28906 4.62149 4.20904 4.70219C4.12174 4.78298 4.0199 4.82338 3.90352 4.82338C3.78705 4.82338 3.68361 4.78298 3.59319 4.70219ZM10.6986 11.8222L9.80336 10.9125C9.72256 10.822 9.68124 10.7171 9.6794 10.5978C9.67755 10.4785 9.71663 10.3785 9.79665 10.2978C9.87666 10.217 9.9767 10.1766 10.0968 10.1766C10.2167 10.1766 10.322 10.2189 10.4125 10.3034L11.3222 11.1986C11.409 11.2793 11.4509 11.3808 11.4479 11.5031C11.4449 11.6254 11.4025 11.7318 11.3206 11.8222C11.2313 11.9127 11.1251 11.958 11.0023 11.958C10.8793 11.958 10.7781 11.9127 10.6986 11.8222ZM1.32373 7.9375C1.19977 7.9375 1.09589 7.89555 1.01208 7.81165C0.928182 7.72774 0.88623 7.62381 0.88623 7.49986C0.88623 7.3758 0.928182 7.27192 1.01208 7.18821C1.09589 7.1044 1.19977 7.0625 1.32373 7.0625H2.60254C2.7265 7.0625 2.83043 7.10445 2.91433 7.18836C2.99814 7.27226 3.04004 7.37619 3.04004 7.50015C3.04004 7.6242 2.99814 7.72808 2.91433 7.81179C2.83043 7.8956 2.7265 7.9375 2.60254 7.9375H1.32373ZM2.68333 11.8222C2.60254 11.7377 2.56122 11.6343 2.55938 11.512C2.55753 11.3898 2.597 11.2883 2.67779 11.2075L3.58196 10.3034C3.66645 10.2189 3.76741 10.1766 3.88486 10.1766C4.0022 10.1766 4.10613 10.2185 4.19665 10.3022C4.28716 10.3935 4.33242 10.4988 4.33242 10.6181C4.33242 10.7374 4.28716 10.8422 4.19665 10.9326L3.30706 11.8222C3.21655 11.9127 3.10985 11.958 2.98696 11.958C2.86407 11.958 2.76286 11.9127 2.68333 11.8222ZM7.00131 10.7083C6.11047 10.7083 5.35281 10.3965 4.72836 9.77296C4.1039 9.14938 3.79167 8.39216 3.79167 7.50131C3.79167 6.61047 4.10346 5.85281 4.72704 5.22836C5.35063 4.6039 6.10784 4.29167 6.99869 4.29167C7.88954 4.29167 8.64719 4.60346 9.27165 5.22704C9.89611 5.85063 10.2083 6.60784 10.2083 7.49869C10.2083 8.38954 9.89654 9.14719 9.27296 9.77165C8.64938 10.3961 7.89216 10.7083 7.00131 10.7083Z"
                                fill="#ECB119"
                              />
                            </g>
                          </svg>
                          {`${singlePackage?.totalDays}D`}
                        </span>
                        {/*                         
                        <span>
                          {singlePackage?.totalDays}D / {singlePackage?.totalNights}
                          N
                        </span> */}
                      </div>
                      <div
                        className={`${styles.starting_location} font_12 flex align_items_center`}
                      >
                        <span className="flex align_items_center">
                          <SvgLocation />
                        </span>
                        {singlePackage?.packageHub}
                      </div>
                    </div>
                  )}

                  {/* Package Name */}
                  <div className={styles.package_name}>
                    {loader ? (
                      <Skeleton width={300} />
                    ) : (
                      <h4>{singlePackage?.packageName}</h4>
                    )}
                  </div>
                  <div
                    className={`${styles.about_package} flex justify_content_between align_items_center`}
                  >
                    {loader ? (
                      <div className="overview-content loading-filter-main">
                        <div className={styles.all_destinations_card}>
                          <b>
                            <Skeleton width={500} />
                          </b>
                        </div>
                      </div>
                    ) : (
                      <div className={styles.all_destinations_wrapper}>
                        {allDestinations &&
                          allDestinations.length > 0 &&
                          allDestinations.map((item, index) => (
                            <div
                              key={index}
                              className={styles.all_destinations_card}
                            >
                              <span>{item.night}N</span> {item.destination}
                            </div>
                          ))}
                      </div>
                    )}

                    {/* {loader ? (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                  </div>
                ) : (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <span>
                        {" "}
                        <PackageDetails
                          packageData={singlePackage}
                          setOpenGetQuotePopup={setOpenGetQuotePopup}
                          selectedCategory={selectedCategory}
                          allPackageHotels={allPackageHotels}
                        />
                      </span>
                    </div>

                    <div className={styles.vertical_line}></div>

                    <div className={styles.options_btns_card}>
                      <NewShare singlePackageData={singlePackage} />
                    </div>
                    <div className={styles.vertical_line}></div>
                    <div className={styles.options_btns_card}>
                      <NewPrint packageData={singlePackage} />
                    </div>
                  </div>
                )} */}
                  </div>
                </div>

                {loader ? (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                  </div>
                ) : (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <span>
                        {/* <PackageDetails
                          packageData={singlePackage}
                          setOpenGetQuotePopup={setOpenGetQuotePopup}
                          selectedCategory={selectedCategory}
                          allPackageHotels={allPackageHotels}
                          selectedMealPlan={selectedMealPlan}
                        /> */}
                        <NewDownloadPdfButton
                          packageData={singlePackage}
                          // setOpenGetQuotePopup={setOpenGetQuotePopup}
                          selectedCategory={selectedCategory}
                          allPackageHotels={allPackageHotels}
                          selectedMealPlan={selectedMealPlan}
                        />
                      </span>
                    </div>

                    <div className={styles.vertical_line}></div>

                    <div className={styles.options_btns_card}>
                      <NewShare singlePackageData={singlePackage} />
                    </div>
                    <div className={styles.vertical_line}></div>
                    <div className={styles.options_btns_card}>
                      {/* <NewPrint packageData={singlePackage} /> */}

                      <NewUIPackagePrint
                        packageData={singlePackage}
                        selectedCategory={selectedCategory}
                        allPackageHotels={allPackageHotels}
                        selectedMealPlan={selectedMealPlan}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* 
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div>
                    {loader ? (
                      <Skeleton width={100} />
                    ) : (
                      <div className="flex flex_gap_10">
                        <div className={`${styles.days_and_night} flex`}>
                          <span className="flex align_items_center">
                            <SvgClock color="#ECB119" />
                          </span>
                          <span>
                            {singlePackage?.totalDays}D /{" "}
                            {singlePackage?.totalNights}N
                          </span>
                        </div>
                        <div
                          className={`${styles.starting_location} font_12 flex align_items_center`}
                        >
                          <span className="flex align_items_center">
                            <SvgLocation />
                          </span>
                          {singlePackage?.packageHub}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.package_name}>
                    {loader ? (
                      <Skeleton width={300} />
                    ) : (
                      <h4>{singlePackage?.packageName}</h4>
                    )}
                  </div>
                  <div className={styles.all_destinations_wrapper}>
                    {allDestinations &&
                      allDestinations.length > 0 &&
                      allDestinations.map((item, index) => (
                        <div
                          key={index}
                          className={styles.all_destinations_card}
                        >
                          <span>{item.night}N</span> {item.destination}
                        </div>
                      ))}
                  </div>
                </div>

                <div>
                {loader ? (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                    <div className={styles.options_btns_card}>
                      <Skeleton width={40} />
                    </div>
                  </div>
                ) : (
                  <div className={styles.options_btns_wrapper}>
                    <div className={styles.options_btns_card}>
                      <span>
                        {" "}
                        <PackageDetails
                          packageData={singlePackage}
                          setOpenGetQuotePopup={setOpenGetQuotePopup}
                          selectedCategory={selectedCategory}
                          allPackageHotels={allPackageHotels}
                        />
                      </span>
                    </div>

                    <div className={styles.vertical_line}></div>

                    <div className={styles.options_btns_card}>
                      <NewShare singlePackageData={singlePackage} />
                    </div>
                    <div className={styles.vertical_line}></div>
                    <div className={styles.options_btns_card}>
                      <NewPrint packageData={singlePackage} />
                    </div>
                  </div>
                )}
                </div>
              </div> */}

              {/* Gallery Section */}
              <div className="">
                {/* Gallery */}

                {loader ? (
                  <div className="overview-content loading-filter-main">
                    {Array.from({ length: 1 }).map((_, index) => (
                      <div className="gallery" key={index}>
                        <div>
                          <Skeleton height={350} />
                        </div>
                        <div className="gallery2">
                          <div>
                            <Skeleton height={170} />
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            <Skeleton height={170} />
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            <Skeleton height={170} />
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            <Skeleton height={170} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {singlePackage?.packageImages && (
                      <div
                        className={styles.gallery}
                        style={{ marginBottom: "0" }}
                      >
                        <div className={styles.gallery1}>
                          <img
                            src={
                              singlePackage?.packageImages[0]
                                ? singlePackage?.packageImages[0]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                          {singlePackage?.packageImages?.length > 1 && (
                            <div>
                              <button
                                className={styles.images_btn}
                                onClick={() => {
                                  Fancybox.show(
                                    singlePackage?.packageImages?.map(
                                      (src) => ({
                                        src,
                                        type: "image",
                                      })
                                    )
                                  );
                                }}
                              >
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 16 15"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                                </svg>
                                See all images
                              </button>
                            </div>
                          )}
                        </div>
                        <div className={styles.gallery2}>
                          <div>
                            <img
                              src={
                                singlePackage?.packageImages[1]
                                  ? singlePackage?.packageImages[1]
                                  : imgNotFound
                              }
                              alt="hotel-image"
                            />
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            <img
                              src={
                                singlePackage?.packageImages[2]
                                  ? singlePackage?.packageImages[2]
                                  : imgNotFound
                              }
                              alt="hotel-image"
                            />
                          </div>
                          {/* <div className="SingleHotel-gallary-sm">
                            <img
                              src={
                                singlePackage?.packageImages[3]
                                  ? singlePackage?.packageImages[3]
                                  : imgNotFound
                              }
                              alt="hotel-image"
                            />
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            <img
                              src={
                                singlePackage?.packageImages[4]
                                  ? singlePackage?.packageImages[4]
                                  : imgNotFound
                              }
                              alt="hotel-image"
                            />
                          </div> */}
                        </div>
                        <div className={styles.package_highlight}>
                          <div className="flex h-full justify_content_between flex_direction_col">
                            <div>
                              <h5> PACKAGE HIGHLIGHTS</h5>
                              <div className="flex flex_gap_10 flex_direction_col">
                                {singlePackage?.validFrom &&
                                  singlePackage?.validTo && (
                                    <div>
                                      <span>Package Validity</span>
                                      <small className="text-capitalize">
                                        {textDateFormatter(
                                          singlePackage?.validFrom
                                        )}{" "}
                                        -{" "}
                                        {textDateFormatter(
                                          singlePackage?.validTo
                                        )}{" "}
                                      </small>
                                    </div>
                                  )}
                                <div>
                                  <span>Transfer</span>
                                  <small className="text-capitalize">
                                    {ratesOfPackages?.VehicleType
                                      ? ratesOfPackages?.VehicleType
                                      : ""}
                                  </small>
                                </div>
                                <div>
                                  {singlePackage?.packageItinerary?.length >
                                    0 &&
                                    singlePackage?.packageItinerary[0]
                                      ?.accommodation?.length > 0 && (
                                      <>
                                        {/* <small>
                                          Stay at{' '}
                                          {
                                            singlePackage?.packageItinerary[0]
                                              ?.accommodation[0]?.starRating
                                          }{' '}
                                          star Hotels.
                                        </small> */}

                                        <div>
                                          {singlePackage?.packageItinerary
                                            ?.length > 0 &&
                                            (() => {
                                              let allAccommodations =
                                                singlePackage.packageItinerary.flatMap(
                                                  (itinerary) =>
                                                    itinerary.accommodation
                                                );

                                              if (selectedCategory) {
                                                allAccommodations =
                                                  allAccommodations.filter(
                                                    (acc) =>
                                                      acc.hotelcategory ===
                                                      selectedCategory
                                                  );
                                              }

                                              allAccommodations.sort(
                                                (a, b) =>
                                                  b.starRating - a.starRating
                                              );

                                              return allAccommodations.length >
                                                0 ? (
                                                <>
                                                  <span>Stay</span>
                                                  <small>
                                                    Stay at{" "}
                                                    {
                                                      allAccommodations[0]
                                                        ?.starRating
                                                    }{" "}
                                                    star Hotels.
                                                  </small>
                                                </>
                                              ) : (
                                                <small>
                                                  No accommodations found for
                                                  this category.
                                                </small>
                                              );
                                            })()}
                                        </div>
                                      </>
                                    )}
                                </div>
                                <div>
                                  {singlePackage?.packageItinerary.length > 0 &&
                                    singlePackage?.packageItinerary[0]
                                      ?.accommodation?.length > 0 && (
                                      <>
                                        <span>Meals</span>
                                        <small>
                                          {mapMealPlan[
                                            selectedMealPlan?.toUpperCase()
                                          ] || ""}{" "}
                                          ({selectedMealPlan?.toUpperCase()})
                                        </small>
                                      </>
                                    )}
                                </div>
                                <div>
                                  {getFirstActivity(singlePackage) && (
                                    <>
                                      <span>Activity</span>
                                      <small>
                                        {getFirstActivity(singlePackage)}
                                      </small>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* <button className={styles.highlight_btn}>
                              All Highlights
                            </button>{" "} */}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {/*  */}
            <section className={` ${styles.main_details_section}`}>
              {/* Filter Section */}
              <div className={`${styles.filter_section}`}>
                <div className={styles.container_inside}>
                  <div className={styles.filter_wrapper}>
                    {mainFilters.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleScrollToSection(item.value)}
                        className={`${styles.filter_card} ${filter === item.value ? styles.active_filter : ""
                          }`}
                      >
                        {item.label}
                      </div>
                    ))}{" "}
                  </div>
                  <div className={styles.mobile_filter_wrapper}>
                    {/* <div
                      onClick={() => handleTabClick("overview")}
                      className={`${
                        styles.filter_card
                      } flex align_items_center justify_content_center flex_gap_5 ${
                        activeFilter === "overview" ? styles.active_filter : ""
                      }`}
                    >
                      Overview{" "}
                      <svg
                        width="11"
                        height="8"
                        viewBox="0 0 13 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          transition: "transform 0.4s",
                          transform: showAllTabs
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      >
                        <path
                          d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                          stroke="#009A50"
                          strokeWidth="1.5"
                        />
                      </svg>
                    </div> */}
                    {mainFilters
                      .filter((item) => item.value !== "overview")
                      .map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleScrollToSection(item.value)}
                          className={`${styles.filter_card} ${filter === item.value ? styles.active_filter : ""
                            }`}
                        >
                          {item.label}{" "}
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className={styles.container_withoutBg}>
                <div className={styles.main_details}>
                  {/* Left Section */}
                  <div className={styles.left_wrapper}>
                    {/* Details Itinerary */}
                    {singlePackage?.packageItinerary?.length > 0 && (
                      <div
                        id="detailed_itinerary"
                        className={`${styles.left_wrapper_inner} ${styles.scroll_section} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("detailed_itinerary")) {
                                return prev.filter(
                                  (item) => item !== "detailed_itinerary"
                                );
                              } else {
                                return [...prev, "detailed_itinerary"];
                              }
                            })
                          }
                        >
                          <h6>Detailed Itinerary</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("detailed_itinerary")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {/* <div className={styles.detailed_itinerary_filter}>
                        {detailedItinerary.map((item, index) => (
                          <div
                            className={`${styles.detailed_itinerary_filter_card
                              } ${detailedFilter === item.value ? styles.active : ""
                              }`}
                            onClick={() => handleDetailedFilter(item.value)}
                            key={index}
                          >
                            {item.label}
                          </div>
                        ))}
                      </div> */}

                        {openOuterAccordion.includes("detailed_itinerary") && (
                          <div
                            className={
                              styles.detailed_itinerary_overview_content
                            }
                          >
                            {singlePackage?.packageItinerary?.length > 0 &&
                              singlePackage?.packageItinerary.map(
                                (item, index) => (
                                  <div
                                    className={
                                      styles.detailed_itinerary_overview_content_card
                                    }
                                  >
                                    <div
                                      style={{
                                        border:
                                          openIndex === index
                                            ? "0.5px solid #333"
                                            : "0.5px solid #ccc",
                                      }}
                                      onClick={() => toggleAccordion(index)}
                                      className={`${styles.detailed_itinerary_overview_content_card_top} pointer`}
                                    >
                                      <div
                                        className={
                                          styles.detailed_itinerary_overview_content_card_heading
                                        }
                                      >
                                        <span>Day {index + 1}</span>

                                        <div
                                          className={
                                            styles.detailed_itinerary_overview_content_card_heading_inner_parent
                                          }
                                        >
                                          <div
                                            className={
                                              styles.detailed_itinerary_overview_content_card_heading_right_upper
                                            }
                                          >
                                            {item?.startDestination} to{" "}
                                            {item?.endDestination}
                                          </div>
                                          <div
                                            className={
                                              styles.details_itinerary_start_end_destination
                                            }
                                          >
                                            Starts At: {item?.startDestination}{" "}
                                            | Ends At: {item?.endDestination}
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        className={`${styles.accordion_icon} ${
                                          openIndex === index
                                            ? styles.active
                                            : ""
                                        }`}
                                      >
                                        <SvgAccordion />
                                      </span>
                                    </div>

                                    <div
                                      className={`
                                  ${
                                    styles.detailed_itinerary_overview_content_card_bottom
                                  } ${openIndex === index ? styles.open : ""}
                                `}
                                    >
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.additionalDetails
                                              ?.short_description,
                                        }}
                                      ></p>
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.additionalDetails
                                              ?.long_description,
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        )}

                        {/* {detailedFilter === "accommodation" && (
                        <div className={styles.detailed_itinerary_categories}>
                          <NewUiSinglePackageAccommodation
                            singlePackage={singlePackage}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                            loader={loader}
                            setSelectedMealPlan={setSelectedMealPlan}
                            selectedMealPlan={selectedMealPlan}
                            allPackageHotels={allPackageHotels}
                            packageRates={packageRates}
                            ratesOfPackages={ratesOfPackages}
                          />
                        </div>
                      )} */}
                      </div>
                    )}

                    {allPackageHotels && allPackageHotels.length > 0 && (
                      <div
                        id="stays"
                        className={`${styles.left_wrapper_inner} ${styles.scroll_section} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() => {
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("stays")) {
                                return prev.filter((item) => item !== "stays");
                              } else {
                                return [...prev, "stays"];
                              }
                            });
                          }}
                        >
                          <h6>Stays</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("stays")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {openOuterAccordion.includes("stays") && (
                          <div className={styles.detailed_itinerary_categories}>
                            <NewUiSinglePackageAccommodation
                              singlePackage={singlePackage}
                              selectedCategory={selectedCategory}
                              setSelectedCategory={setSelectedCategory}
                              loader={loader}
                              setSelectedMealPlan={setSelectedMealPlan}
                              selectedMealPlan={selectedMealPlan}
                              allPackageHotels={allPackageHotels}
                              packageRates={packageRates}
                              ratesOfPackages={ratesOfPackages}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {/* Inclusions / Exclusions */}

                    {singlePackage?.packagePolicies?.length > 0 && (
                      <div
                        id="inclusion_exclusion"
                        className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() => {
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("inclusion_exclusion")) {
                                return prev.filter(
                                  (item) => item !== "inclusion_exclusion"
                                );
                              } else {
                                return [...prev, "inclusion_exclusion"];
                              }
                            });
                          }}
                        >
                          <h6>Inclusions / Exclusions</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("inclusion_exclusion")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>
                        {openOuterAccordion.includes("inclusion_exclusion") && (
                          <div className={styles.inclusion_exclusion_content}>
                            <div className={styles.inclusion_content}>
                              {singlePackage?.packagePolicies?.length > 0 &&
                                singlePackage?.packagePolicies
                                  .filter((item) => item.type === "inclusion")
                                  .map((item, index) => (
                                    <>
                                      <div
                                        className={
                                          styles.inclusion_content_heading
                                        }
                                      >
                                        Inclusions
                                      </div>

                                      <div
                                        key={index}
                                        className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    </>
                                  ))}
                            </div>
                            <div className={styles.exclusion_content}>
                              {singlePackage?.packagePolicies?.length > 0 &&
                                singlePackage?.packagePolicies
                                  .filter((item) => item.type === "exclusion")
                                  .map((item, index) => (
                                    <>
                                      <div
                                        className={
                                          styles.exclusion_content_heading
                                        }
                                      >
                                        Exclusive
                                      </div>
                                      <div
                                        key={index}
                                        className={`${styles.inner_common_content} ${styles.exclusive_inner_content}`}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    </>
                                  ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Points To Remember */}

                    {singlePackage?.packagePolicies?.filter(
                      (item) => item.type === "points_to_remember"
                    )?.length > 0 && (
                      <div
                        id="points_to_remember"
                        // className={styles.left_wrapper_inner}
                        className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() => {
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("points_to_remember")) {
                                return prev.filter(
                                  (item) => item !== "points_to_remember"
                                );
                              } else {
                                return [...prev, "points_to_remember"];
                              }
                            });
                          }}
                        >
                          <h6>Things to Know</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("points_to_remember")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>
                        {openOuterAccordion.includes("points_to_remember") && (
                          <div className={styles.inner_common_content_style}>
                            {singlePackage?.packagePolicies?.length > 0 &&
                              singlePackage.packagePolicies
                                .filter(
                                  (item) => item.type === "points_to_remember"
                                )
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={styles.inner_common_content}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Terms & Conditions */}
                    {singlePackage?.packagePolicies?.filter(
                      (item) => item.type === "terms_and_conditions"
                    )?.length > 0 && (
                      <div
                        id="terms_and_conditions"
                        className={styles.left_wrapper_inner}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() => {
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("terms_and_conditions")) {
                                return prev.filter(
                                  (item) => item !== "terms_and_conditions"
                                );
                              } else {
                                return [...prev, "terms_and_conditions"];
                              }
                            });
                          }}
                        >
                          <h6>Terms & Conditions</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes(
                                "terms_and_conditions"
                              )
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {openOuterAccordion.includes(
                          "terms_and_conditions"
                        ) && (
                          <div className={styles.inner_common_content_style}>
                            {singlePackage?.packagePolicies?.length > 0 &&
                              singlePackage.packagePolicies
                                .filter(
                                  (item) => item.type === "terms_and_conditions"
                                )
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={styles.inner_common_content}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Cancellation Policy */}
                    {singlePackage?.packagePolicies?.filter(
                      (item) => item.type === "cancellation_policy"
                    )?.length > 0 && (
                      <div
                        id="cancellation_policy"
                        className={styles.left_wrapper_inner}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() => {
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("cancellation_policy")) {
                                return prev.filter(
                                  (item) => item !== "cancellation_policy"
                                );
                              } else {
                                return [...prev, "cancellation_policy"];
                              }
                            });
                          }}
                        >
                          <h6>Cancellation Policy</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("cancellation_policy")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {openOuterAccordion.includes("cancellation_policy") && (
                          <div
                            className={`${styles.inner_common_content_style}`}
                          >
                            {singlePackage?.packagePolicies?.length > 0 &&
                              singlePackage.packagePolicies
                                .filter(
                                  (item) => item.type === "cancellation_policy"
                                )
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={styles.inner_common_content}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Right Section */}
                  <div className={styles.right_wrapper}>
                    <aside
                      className={` ${styles.price_breakup_aside}`}
                      style={{
                        width: "100%",
                        background: "#fff",
                        // border: "0.5px solid #aaa",
                      }}
                      id="Price-Break"
                    >
                      <div className="common_background common_background_parent_sticky m_0">
                        {singlePackage &&
                          singlePackage?.packageRates &&
                          singlePackage?.packageRates.length > 0 && (
                            <div
                              style={{
                                padding: "10px",
                                border: "0.5px solid #ccc",
                              }}
                            >
                              <label>Select Accommodation</label>
                              <select
                                className="w-full"
                                name="meal_plan"
                                value={selectedCategory}
                                onChange={(e) =>
                                  setSelectedCategory(e.target.value)
                                }
                              >
                                <option value="">Select an option</option>
                                {allCategories.map((category) => (
                                  <option
                                    key={category?.value}
                                    value={category?.value}
                                  >
                                    {category?.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        {/* <hr /> */}
                        {singlePackage &&
                          singlePackage?.packageRates &&
                          singlePackage?.packageRates.length > 0 && (
                            <div
                              style={{
                                padding: "10px",
                                border: "0.5px solid #ccc",
                                borderTop: "0",
                                borderBottom: "0",
                              }}
                            >
                              <label>Select Meal Plan</label>
                              <select
                                className="w-full"
                                name="meal_plan"
                                value={selectedMealPlan}
                                onChange={(e) =>
                                  setSelectedMealPlan(e.target.value)
                                }
                              >
                                <option value="">Select an option</option>
                                {Array.from(
                                  new Set(
                                    singlePackage?.packageRates.map(
                                      (rate) => rate.mealPlan
                                    )
                                  )
                                )
                                  .sort((a, b) => {
                                    const order = ["ep", "cp", "map", "ap"];
                                    return order.indexOf(a) - order.indexOf(b);
                                  })
                                  .map((mealPlan) => (
                                    <option key={mealPlan} value={mealPlan}>
                                      {mapMealPlan[mealPlan?.toUpperCase()]}
                                      {"  "}({mealPlan.toUpperCase()})
                                    </option>
                                  ))}
                              </select>
                            </div>
                          )}

                        {singlePackage?.packageAddons &&
                          singlePackage?.packageAddons.length > 0 && (
                            <div
                              className={`${styles.addons_container} ${styles.desktop_addon}`}
                            >
                              <div
                                className="flex align_items_center justify_content_between pointer"
                                onClick={toggleAccordionAddon}
                              >
                                <h5
                                  style={{ color: "#333", fontWeight: "600" }}
                                >
                                  Add Ons
                                </h5>
                                <svg
                                  width="25px"
                                  height="25px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  style={{
                                    cursor: "pointer",
                                    transform: isExpandedAddon
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                  }}
                                >
                                  <path
                                    d="M7 10L12 15L17 10"
                                    stroke="#016937"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>

                              <div
                                className="overflow-width"
                                style={{
                                  display: isExpandedAddon ? "block" : "none",
                                }}
                              >
                                {singlePackage.packageAddons
                                  .filter(
                                    (item) =>
                                      !item.detail.includes("Volvo") &&
                                      item.addonType !== "ticket"
                                  )
                                  .map((item, index) => {
                                    let finalAddonPrice = item?.price;
                                    let priceWithMarkup = item?.price;

                                    if (markupData) {
                                      const markup = markupData;
                                      if (markup.markupType === "percentage") {
                                        finalAddonPrice +=
                                          (item.price *
                                            parseFloat(markup.amount)) /
                                          100;
                                      } else if (
                                        markup.markupType === "fixed"
                                      ) {
                                        finalAddonPrice += parseFloat(
                                          markup.amount
                                        );
                                      }
                                    }
                                    priceWithMarkup = finalAddonPrice;

                                    if (
                                      commission?.commissionAmount &&
                                      commission?.commissionType
                                    ) {
                                      if (
                                        commission?.commissionType ===
                                        "percentage"
                                      ) {
                                        finalAddonPrice -=
                                          (Number(finalAddonPrice) *
                                            Number(
                                              commission?.commissionAmount
                                            )) /
                                          100;
                                      } else if (
                                        commission?.commissionType === "fixed"
                                      ) {
                                        finalAddonPrice = Number(
                                          commission?.commissionAmount
                                        );
                                      }
                                    }

                                    return (
                                      <div
                                        key={index}
                                        className={`${styles.addon_inner_card
                                          } ${selectedAddOns.some(
                                            (addon) => addon.id === item.id
                                          )
                                            ? styles.selected
                                            : ""
                                          } flex justify_content_between w-100 mt-7`}
                                      >
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            width: "80%",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "15px",
                                              fontWeight: 500,
                                            }}
                                          >
                                            <span className="font_12">
                                              {item.detail}
                                            </span>{" "}
                                            {commission?.commissionAmount &&
                                              commission?.commissionType && (
                                                <span
                                                  className={`${selectedAddOns.some(
                                                    (addon) =>
                                                      addon.id === item.id
                                                  )
                                                    ? styles.selected_price
                                                    : ""
                                                    }`}
                                                  style={{
                                                    fontSize: "12px",
                                                    color: "red",
                                                    textDecoration:
                                                      "line-through",
                                                  }}
                                                >
                                                  {formatIndianCurrency(
                                                    priceWithMarkup
                                                  )}{" "}
                                                  {item.perPerson
                                                    ? `* ${guest}`
                                                    : ""}
                                                </span>
                                              )}
                                            <span
                                              className={`${styles.addon_price
                                                } ${selectedAddOns.some(
                                                  (addon) =>
                                                    addon.id === item.id
                                                )
                                                  ? styles.selected_price
                                                  : ""
                                                }`}
                                            >
                                              {formatIndianCurrency(
                                                finalAddonPrice
                                              )}{" "}
                                              {item.perPerson
                                                ? `* ${guest}`
                                                : ""}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="">
                                          <button
                                            style={{ fontSize: "10px" }}
                                            onClick={() =>
                                              handleSelectedAddOns({
                                                ...item,
                                                finalAddonPrice,
                                                priceWithMarkup,
                                              })
                                            }
                                          >
                                            {selectedAddOns.some(
                                              (addon) => addon.id === item.id
                                            ) ? (
                                              <div style={{ color: "red" }}>
                                                <CrossWithBorder />
                                              </div>
                                            ) : (
                                              <div
                                                style={{
                                                  background: "#009A50",
                                                  color: "#fff",
                                                  padding: "5px 7px",
                                                }}
                                              >
                                                ADD
                                              </div>
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )}

                        <div
                          className="flex justify_content_between align_items_center pointer pb_10"
                          onClick={() => {
                            handleButtonClick();
                            togglePaymentDetails();
                          }}
                          style={{
                            padding: "10px 10px",
                            backgroundColor: "#FDF7E4",
                            borderBottom: "0.5px solid #CCCCCC",
                          }}
                        >
                          <h4 style={{ fontSize: "16px", fontWeight: "600" }}>
                            Price Breakup
                          </h4>
                          <div style={{ backgroundColor: "#FDF7E4" }}>
                            <button
                              className={`${activePayment === "priceSummary" ? "" : ""
                                }`}
                            >
                              {/* <small className="link_btn">
                                {activePayment === "priceSummary"
                                  ? "Minimize Breakup"
                                  : "View Breakup"}{" "}
                              </small> */}
                              {/* <svg
                                width="13"
                                height="8"
                                viewBox="0 0 13 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  transition: "transform 0.3s",
                                  transform: paymentDetails
                                    ? "rotate(0deg)"
                                    : "rotate(180deg)",
                                }}
                              >
                                <path
                                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                  stroke="#222222"
                                  strokeWidth="1.5"
                                />
                              </svg> */}

                              {paymentDetails ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_6868_15102"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="19"
                                  >
                                    <rect
                                      y="0.5"
                                      width="18"
                                      height="18"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_6868_15102)">
                                    <path
                                      d="M4.38462 14.1154H7.38462C7.58077 14.1154 7.74523 14.1818 7.878 14.3145C8.01062 14.4473 8.07692 14.6118 8.07692 14.8079C8.07692 15.0042 8.01062 15.1686 7.878 15.3011C7.74523 15.4337 7.58077 15.5 7.38462 15.5H3.83446C3.598 15.5 3.39985 15.42 3.24 15.26C3.08 15.1002 3 14.902 3 14.6655V11.1154C3 10.9192 3.06638 10.7548 3.19915 10.622C3.33192 10.4894 3.49638 10.4231 3.69254 10.4231C3.88885 10.4231 4.05323 10.4894 4.18569 10.622C4.31831 10.7548 4.38462 10.9192 4.38462 11.1154V14.1154ZM13.6154 4.88462H10.6154C10.4192 4.88462 10.2548 4.81823 10.122 4.68546C9.98938 4.55269 9.92308 4.38823 9.92308 4.19208C9.92308 3.99577 9.98938 3.83138 10.122 3.69892C10.2548 3.56631 10.4192 3.5 10.6154 3.5H14.1655C14.402 3.5 14.6002 3.58 14.76 3.74C14.92 3.89985 15 4.098 15 4.33446V7.88462C15 8.08077 14.9336 8.24523 14.8008 8.378C14.6681 8.51062 14.5036 8.57692 14.3075 8.57692C14.1112 8.57692 13.9468 8.51062 13.8143 8.378C13.6817 8.24523 13.6154 8.08077 13.6154 7.88462V4.88462Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_6868_15096"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="19"
                                  >
                                    <rect
                                      y="0.5"
                                      width="18"
                                      height="18"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_6868_15096)">
                                    <path
                                      d="M6.69231 11.8077H3.69231C3.49615 11.8077 3.33177 11.7413 3.19915 11.6085C3.06638 11.4758 3 11.3113 3 11.1152C3 10.9188 3.06638 10.7545 3.19915 10.622C3.33177 10.4894 3.49615 10.4231 3.69231 10.4231H7.24269C7.479 10.4231 7.67715 10.503 7.83715 10.6628C7.997 10.8228 8.07692 11.021 8.07692 11.2573V14.8077C8.07692 15.0038 8.01054 15.1682 7.87777 15.3008C7.745 15.4336 7.58054 15.5 7.38438 15.5C7.18808 15.5 7.02369 15.4336 6.89123 15.3008C6.75862 15.1682 6.69231 15.0038 6.69231 14.8077V11.8077ZM11.3077 7.19231H14.3077C14.5038 7.19231 14.6682 7.25869 14.8008 7.39146C14.9336 7.52423 15 7.68869 15 7.88485C15 8.08115 14.9336 8.24554 14.8008 8.378C14.6682 8.51062 14.5038 8.57692 14.3077 8.57692H10.7573C10.521 8.57692 10.3228 8.497 10.1628 8.33715C10.003 8.17715 9.92308 7.979 9.92308 7.74269V4.19231C9.92308 3.99615 9.98946 3.83177 10.1222 3.69915C10.255 3.56638 10.4195 3.5 10.6156 3.5C10.8119 3.5 10.9763 3.56638 11.1088 3.69915C11.2414 3.83177 11.3077 3.99615 11.3077 4.19231V7.19231Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                              )}
                            </button>
                          </div>
                        </div>
                        <div
                          style={{
                            padding: "10px",
                            background: "#FDF7E4",
                          }}
                        >
                          <>
                            {activePayment === "priceSummary" && (
                              <>
                                <div className="flex justify_content_between">
                                  <p>
                                    Adult Cost{" "}
                                    <small>
                                      (
                                      {calculationsOfPackages?.onlyAdultCost /
                                        calculationsOfPackages?.adultNumber}{" "}
                                      X {calculationsOfPackages?.adultNumber})
                                    </small>
                                  </p>
                                  <span
                                    className={`room_text-right ${Number(
                                      calculationsOfPackages?.onlyAdultCost
                                    ) <= 0 && "filterBlur3"
                                      }`}
                                  >
                                    {priceLoader ? (
                                      <Skeleton
                                        width={80}
                                        height={10}
                                        borderRadius={4}
                                      />
                                    ) : (
                                      <>
                                        {formatIndianCurrency(
                                          calculationsOfPackages?.onlyAdultCost
                                        )}
                                      </>
                                    )}
                                  </span>
                                </div>

                                {calculationsOfPackages?.extraAdultNumber > 0 &&
                                  calculationsOfPackages?.ExtraAdultCost ? (
                                  <div className="flex justify_content_between mt-7">
                                    <p>
                                      Extra Adult Cost{" "}
                                      <small>
                                        (
                                        {calculationsOfPackages?.ExtraAdultCost /
                                          calculationsOfPackages?.extraAdultNumber}{" "}
                                        X{" "}
                                        {
                                          calculationsOfPackages?.extraAdultNumber
                                        }
                                        )
                                      </small>
                                    </p>
                                    <span
                                      className={`room_text-right ${Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                        }`}
                                    >
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.ExtraAdultCost
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </div>
                                ) : null}

                                {under6AgeChildren?.length > 0 &&
                                  calculationsOfPackages?.childNumber > 0 &&
                                  calculationsOfPackages?.childCostWithOutBed ? (
                                  <div className="flex justify_content_between mt-7">
                                    <p>
                                      Child Cost ({`< 6 yrs`}){" "}
                                      {/* <small>
                                         (
                                        {Math.round(
                                          calculationsOfPackages?.childCostWithOutBed /
                                          under6AgeChildren.length
                                        )}
                                        X {under6AgeChildren.length})
                                      </small> */}
                                    </p>
                                    <span
                                      className={`room_text-right ${Number(
                                        calculationsOfPackages?.childCostWithOutBed
                                      ) <= 0 && "filterBlur3"
                                        }`}
                                    >
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.childCostWithOutBed
                                      )}
                                    </span>
                                  </div>
                                ) : null}

                                {
                                  // over6AgeChildren?.length > 0 &&
                                  calculationsOfPackages?.childNumber > 0 &&
                                    newChildAge?.length > 0 ? (
                                    // calculationsOfPackages?.childCostWithBed ? es?.childCostWithBed ?
                                    <div
                                      className="flex justify_content_between mt-7"
                                      onClick={() =>
                                        setShowChildBreakUpPopup(
                                          !showChildBreakUpPopup
                                        )
                                      }
                                    >
                                      <p>
                                        Child Cost
                                        <button>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="17"
                                            viewBox="0 0 16 17"
                                            fill="none"
                                            style={{
                                              transition: "transform 0.5s",
                                              transform: showChildBreakUpPopup
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                            }}
                                          >
                                            <mask
                                              id="mask0_7293_4207"
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="16"
                                              height="17"
                                            >
                                              <rect
                                                y="16.5"
                                                width="16"
                                                height="16"
                                                transform="rotate(-90 0 16.5)"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_7293_4207)">
                                              <path
                                                d="M7.99998 10.6204L13.1436 5.47694C13.2419 5.37861 13.3594 5.33005 13.4961 5.33128C13.6329 5.33261 13.7504 5.38244 13.8486 5.48078C13.947 5.579 13.9961 5.6965 13.9961 5.83328C13.9961 5.97005 13.947 6.08755 13.8486 6.18578L8.75765 11.2808C8.64998 11.3884 8.52993 11.4671 8.39748 11.5166C8.26493 11.5662 8.13242 11.5909 7.99998 11.5909C7.86754 11.5909 7.73504 11.5662 7.60248 11.5166C7.47004 11.4671 7.34998 11.3884 7.24231 11.2808L2.14748 6.18578C2.04915 6.08755 2.00065 5.96939 2.00198 5.83128C2.0032 5.69328 2.05298 5.57516 2.15131 5.47694C2.24954 5.37861 2.36704 5.32944 2.50381 5.32944C2.64059 5.32944 2.75809 5.37861 2.85631 5.47694L7.99998 10.6204Z"
                                                fill="#1C1B1F"
                                              />
                                            </g>
                                          </svg>
                                        </button>
                                        {/* ({`>= 6 yrs`}){" "} */}
                                        {/* <small>
                                        (
                                        {calculationsOfPackages?.childCostWithBed /
                                          over6AgeChildren.length}{" "}
                                        X {over6AgeChildren.length})
                                      </small> */}
                                      </p>
                                      <span
                                        className={`room_text-right ${Number(
                                          calculationsOfPackages?.childCostWithBed
                                        ) <= 0 && "filterBlur3"
                                          }`}
                                      >
                                        {priceLoader ? (
                                          <Skeleton
                                            width={80}
                                            height={10}
                                            borderRadius={4}
                                          />
                                        ) : (
                                          <>
                                            {formatIndianCurrency(
                                              calculationsOfPackages?.childCostWithBed
                                            )}
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  ) : null
                                }

                                {showChildBreakUpPopup && (
                                  <>
                                    {newChildAge && newChildAge?.length > 0 ? (
                                      <>
                                        {newChildAge.map((item, childIndex) => (
                                          <div
                                            className="flex justify_content_between mt-7"
                                            key={childIndex}
                                          >
                                            <p>
                                              Child {childIndex + 1}{" "}
                                              <small>({item?.age} years)</small>
                                            </p>
                                            <span>
                                              {item?.type === "complimentary"
                                                ? "Complimentary"
                                                : item?.type === "withbed"
                                                  ? "With Bed"
                                                  : "Without Bed"}

                                              {item?.type ===
                                                "complimentary" && (
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="15"
                                                    viewBox="0 0 14 15"
                                                    fill="none"
                                                    style={{
                                                      marginLeft: "5px",
                                                      marginRight: "0",
                                                    }}
                                                  >
                                                    <path
                                                      d="M7.23677 2L7.62744 2.03349C10.0613 2.30369 12.0579 4.21784 12.4328 6.6365C12.991 10.2387 9.99351 13.3663 6.37368 12.9652C3.85393 12.686 1.81434 10.6468 1.53556 8.12637L1.50206 7.73571C1.50685 7.57866 1.49559 7.41992 1.50206 7.26315C1.61873 4.45834 3.91135 2.13003 6.72128 2H7.23677ZM7.24747 6.54348H5.02451L5.40575 5.97424H7.18301C7.09098 5.77399 6.93688 5.61652 6.73578 5.52462C6.48317 5.40923 6.20551 5.39375 5.93235 5.37222L5.02451 5.3725L5.40575 4.8034H9.1376L8.77241 5.37264H7.77365C7.91086 5.54798 8.02035 5.75021 8.05286 5.9741H9.13746L8.77016 6.54109L8.08101 6.54475L7.98841 6.8656L11.3282 6.09217C10.8462 4.56248 9.52657 3.37869 7.95815 3.04517C5.18199 2.45497 2.57625 4.49915 2.44664 7.311V7.67703L2.49012 8.13312L7.07282 7.07303C7.1885 6.92611 7.25408 6.73135 7.24747 6.54348ZM8.39652 10.8721H7.42465L5.25629 8.16436L5.22829 8.09006L2.60791 8.69166C3.05163 10.3835 4.49213 11.6876 6.21438 11.9856C9.24301 12.5098 11.8894 9.96988 11.5201 6.92597C11.5109 6.84956 11.4972 6.73951 11.4783 6.66704C11.4751 6.65479 11.4866 6.64748 11.4624 6.65043L7.48108 7.56656C7.08676 7.85364 6.61897 8.01238 6.1305 8.03644L8.39652 10.8721Z"
                                                      fill="#EB442D"
                                                    />
                                                  </svg>
                                                )}
                                              {item?.age >= 6 && (
                                                <button
                                                  className="pointer tooltip"
                                                  onClick={() =>
                                                    handleTypeChange(childIndex)
                                                  }
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14"
                                                    fill="none"
                                                    style={{
                                                      marginLeft: "5px",
                                                      marginRight: "0",
                                                    }}
                                                  >
                                                    <mask
                                                      id="mask0_7293_4275"
                                                      maskUnits="userSpaceOnUse"
                                                      x="0"
                                                      y="0"
                                                      width="14"
                                                      height="14"
                                                    >
                                                      <rect
                                                        width="14"
                                                        height="14"
                                                        fill="#D9D9D9"
                                                      />
                                                    </mask>
                                                    <g mask="url(#mask0_7293_4275)">
                                                      <path
                                                        d="M5.34455 7.37578C5.22049 7.37578 5.11656 7.33383 5.03276 7.24993C4.94905 7.16613 4.90719 7.06224 4.90719 6.93828V3.12868L3.55546 4.48041C3.47652 4.5612 3.37789 4.6016 3.25957 4.6016C3.14125 4.6016 3.03683 4.55974 2.94632 4.47603C2.8558 4.38474 2.81055 4.28038 2.81055 4.16293C2.81055 4.04558 2.8558 3.94165 2.94632 3.85114L4.97005 1.82741C5.02459 1.77277 5.08239 1.73427 5.14344 1.71191C5.2046 1.68945 5.27007 1.67822 5.33988 1.67822C5.40969 1.67822 5.47599 1.6895 5.5388 1.71206C5.6016 1.73471 5.65994 1.77316 5.7138 1.82741L7.75211 3.86572C7.83883 3.95245 7.88161 4.05302 7.88044 4.16745C7.87937 4.28188 7.83358 4.38474 7.74307 4.47603C7.65255 4.55974 7.55008 4.6031 7.43565 4.60612C7.32122 4.60903 7.2188 4.56528 7.12838 4.47487L5.78219 3.12868V6.94383C5.78219 7.06623 5.74024 7.1688 5.65634 7.25154C5.57244 7.33437 5.46851 7.37578 5.34455 7.37578ZM8.65876 12.3162C8.58895 12.3162 8.52264 12.3049 8.45984 12.2822C8.39703 12.2596 8.3387 12.2212 8.28484 12.167L6.24653 10.1287C6.1598 10.0419 6.11703 9.94129 6.11819 9.82695C6.11926 9.71252 6.16505 9.60966 6.25557 9.51837C6.34608 9.43466 6.44855 9.3913 6.56298 9.38829C6.67742 9.38527 6.77984 9.42902 6.87026 9.51953L8.21644 10.8657V7.05043C8.21644 6.92813 8.25839 6.82556 8.3423 6.74272C8.4262 6.65999 8.53013 6.61862 8.65409 6.61862C8.77814 6.61862 8.88207 6.66052 8.96588 6.74433C9.04959 6.82823 9.09144 6.93216 9.09144 7.05612V10.8657L10.4432 9.51385C10.5221 9.43315 10.6207 9.39281 10.7391 9.39281C10.8574 9.39281 10.9618 9.43466 11.0523 9.51837C11.1428 9.60966 11.1881 9.71398 11.1881 9.83133C11.1881 9.94877 11.1428 10.0528 11.0523 10.1433L9.02859 12.167C8.97405 12.2215 8.91625 12.26 8.85519 12.2825C8.79404 12.305 8.72856 12.3162 8.65876 12.3162Z"
                                                        fill="#EB442D"
                                                      />
                                                    </g>
                                                  </svg>

                                                  <span
                                                    className="tooltip_text"
                                                    style={{
                                                      right: "0",
                                                      left: "auto",
                                                      fontSize: "12px",
                                                      width: "100px",
                                                    }}
                                                  >
                                                    Switch to another option
                                                  </span>
                                                </button>
                                              )}
                                            </span>
                                          </div>
                                        ))}
                                      </>
                                    ) : null}
                                  </>
                                )}
                              </>
                            )}

                            <div
                              className="flex justify_content_between"
                              style={{ paddingTop: "7px" }}
                            >
                              <h6>Total Package Cost</h6>
                              <h6
                                className={`room_text-right alert_text ${Number(calculationsOfPackages?.totalAmount) <=
                                  0 && "filterBlur3"
                                  }`}
                              >
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.basePrice
                                    )}
                                  </>
                                )}
                              </h6>
                            </div>

                            {activePayment === "priceSummary" && (
                              <>
                                {(selectedAutomaticDiscount?.length > 0 ||
                                  selectedDiscount?.length > 0) && (
                                    <div
                                      className="mt-7 pt_10"
                                      style={{ borderTop: "0.5px solid #ccc" }}
                                    >
                                      <p>
                                        <b>
                                          Package Discount
                                          {selectedAutomaticDiscount?.length > 1
                                            ? "s"
                                            : ""}
                                        </b>
                                      </p>
                                      {selectedAutomaticDiscount?.map(
                                        (discount, index) => (
                                          <div
                                            className="flex justify_content_between mt-2"
                                            key={discount.id}
                                          >
                                            <span className="discount-name">
                                              {discount.promotionName}
                                            </span>
                                            <span className="room_text-right green">
                                              {discount.promotionMode ===
                                                "percentage"
                                                ? `${+discount.promotionAmount}%`
                                                : `${formatIndianCurrency(
                                                  discount.promotionAmount
                                                )}`}
                                            </span>
                                          </div>
                                        )
                                      )}

                                      {selectedDiscount &&
                                        selectedDiscount?.length > 0 &&
                                        selectedDiscount?.map(
                                          (discount, index) => (
                                            <div
                                              className="flex justify_content_between mt-2"
                                              key={discount.id}
                                            >
                                              <span className="discount-name">
                                                {discount.promotionName}
                                              </span>
                                              <span className="room_text-right green">
                                                {discount.promotionMode ===
                                                  "percentage"
                                                  ? `${+discount.promotionAmount}%`
                                                  : `${formatIndianCurrency(
                                                    discount.promotionAmount
                                                  )}`}
                                              </span>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  )}

                                {calculationsOfPackages?.discount > 0 && (
                                  <div
                                    className="flex justify_content_between mt-7 border-bottom-one "
                                    style={{ paddingBottom: "7px" }}
                                  >
                                    <p>Package Cost (After Disc.)</p>
                                    <span
                                      className={`room_text-right ${Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                        }`}
                                    >
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.priceAfterDiscount
                                      )}
                                    </span>
                                  </div>
                                )}

                                {commission &&
                                  Object.keys(commission)?.length > 0 && (
                                    <>
                                      <div className="flex justify_content_between mt-7">
                                        <p>
                                          Commission{" "}
                                          <small>
                                            ({" "}
                                            {commission.commissionType ===
                                              "fixed" ? (
                                              <span className="room_text-right">
                                                {formatIndianCurrency(
                                                  commission?.commissionAmount
                                                )}
                                              </span>
                                            ) : (
                                              <span className="room_text-right">
                                                {commission?.commissionAmount}%
                                              </span>
                                            )}
                                            )
                                          </small>
                                        </p>

                                        {formatIndianCurrency(
                                          calculationsOfPackages?.calculatedCommissionAmount
                                        )}
                                      </div>
                                    </>
                                  )}
                                <div
                                  className="flex justify_content_between mt-7"
                                  style={{
                                    borderTop: "0.5px solid #cccccc7c",
                                    paddingTop: "10px",
                                  }}
                                >
                                  <p>Subtotal </p>
                                  <span
                                    className={`room_text-right alert_text`}
                                  >
                                    {priceLoader ? (
                                      <Skeleton
                                        width={80}
                                        height={10}
                                        borderRadius={4}
                                      />
                                    ) : (
                                      <>
                                        {formatIndianCurrency(
                                          calculationsOfPackages?.subtotal
                                        )}
                                      </>
                                    )}
                                  </span>
                                </div>
                              </>
                            )}

                            {selectedAddOns && selectedAddOns?.length > 0 && (
                              <div className="flex justify_content_between mt-7">
                                <p>Addons Price</p>
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {commission &&
                                    Object.keys(commission)?.length > 0 && (
                                      <small
                                        style={{
                                          color: "red",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {formatIndianCurrency(
                                          totalAddonsCostWithoutCommission
                                        )}
                                      </small>
                                    )}
                                  <b>{formatIndianCurrency(totalAddonsCost)}</b>
                                </span>
                              </div>
                            )}

                            <div
                              className="flex justify_content_between mt-7 border-bottom-one "
                              style={{ paddingBottom: "7px" }}
                            >
                              <p>GST(5%) </p>
                              <span
                                className={`room_text-right  ${Number(calculationsOfPackages?.totalAmount) <=
                                  0 && "filterBlur3"
                                  }`}
                              >
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.taxAmount
                                    )}
                                  </>
                                )}
                              </span>
                            </div>

                            <div
                              className="flex justify_content_between mt-7 border-bottom-one "
                              style={{ paddingBottom: "7px" }}
                            >
                              <p>Vehicle</p>
                              <span className="room_text-right">
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <span style={{ textTransform: "capitalize" }}>
                                    <strong>
                                      {ratesOfPackages?.VehicleType?.replace(
                                        /-/g,
                                        " "
                                      )}
                                    </strong>
                                  </span>
                                )}
                              </span>
                            </div>

                            <div className="flex justify_content_between mt-7">
                              <h6>Total Amount to be paid</h6>
                              <h6>
                                <span
                                  className={` ${Number(
                                    calculationsOfPackages?.totalAmount
                                  ) <= 0 && "filterBlur3"
                                    }`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {priceLoader ? (
                                    <Skeleton
                                      width={80}
                                      height={10}
                                      borderRadius={4}
                                    />
                                  ) : (
                                    <>
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.totalAmount
                                      )}
                                    </>
                                  )}
                                </span>
                              </h6>
                              {/* <button onClick={() => setShowVehicleSlider(true)}>Change</button> */}
                            </div>

                            {/* <div
                              className="flex justify_content_between mt-7 border-bottom-one "
                              style={{ paddingBottom: "7px" }}
                            >
                              <p>Transfer</p>
                              <span className="text-capitalize">
                                {ratesOfPackages?.VehicleType ? ratesOfPackages?.VehicleType : ''}
                              </span>
                            </div> */}
                          </>
                          {/* )} */}
                        </div>

                        {promotions.length > 0 && (
                          <>
                            {promotions.some(
                              (item) =>
                                item.promotionType === "coupon" &&
                                (() => {
                                  const isValidDate = checkDates(
                                    item.startDate,
                                    item.endDate
                                  );
                                  const isBookingWithinDiscount =
                                    checkBookingDates(
                                      startDate,
                                      startDate,
                                      item.startDate,
                                      item.endDate
                                    );
                                  const isUserEligible = isPromotionApplicable(
                                    userType === "customer"
                                      ? "customers"
                                      : userType === "agent"
                                        ? "agents"
                                        : "",
                                    userDetails?.id,
                                    item.promotionApplicable
                                  );
                                  const blackoutDates =
                                    item.promotionBlackOutDate || [];
                                  const isBlackout = isBlackoutDate(
                                    blackoutDates,
                                    startDate
                                  );
                                  const isApplicableForEntity =
                                    isPromotionApplicableForEntity(
                                      item.promotionEntity,
                                      "package",
                                      singlePackage?.packageId
                                    );
                                  const isConditionsValid = evaluateConditions(
                                    item.promotionConditions,
                                    startDate
                                  );

                                  return (
                                    isValidDate &&
                                    isBookingWithinDiscount &&
                                    isUserEligible &&
                                    !isBlackout &&
                                    isApplicableForEntity &&
                                    isConditionsValid
                                  );
                                })()
                            ) && (
                                <div className={`${styles.discount_wrapper}`}>
                                  <div
                                    className={` flex justify_content_between cursor_pointer`}
                                  >
                                    <div className="flex justify_content_between w-100">
                                      <div>
                                        <h5 className="text-left">Discounts</h5>
                                      </div>
                                      {selectedDiscount && (
                                        <button
                                          className="view_btn"
                                          onClick={() => setSelectedDiscount([])}
                                        >
                                          clear
                                        </button>
                                      )}
                                    </div>
                                  </div>

                                  <div>
                                    {promotions?.map((item, index) => {
                                      const isCouponCode =
                                        item?.promotionType === "coupon"
                                          ? true
                                          : false;
                                      const isValidDate = checkDates(
                                        item.startDate,
                                        item.endDate
                                      );
                                      const isBookingWithinDiscount =
                                        checkBookingDates(
                                          startDate,
                                          startDate,
                                          item.startDate,
                                          item.endDate
                                        );
                                      const isUserEligible =
                                        isPromotionApplicable(
                                          userType === "customer"
                                            ? "customers"
                                            : userType === "agent"
                                              ? "agents"
                                              : "",
                                          userDetails?.id,
                                          item.promotionApplicable
                                        );
                                      const blackoutDates =
                                        item.promotionBlackOutDate || [];
                                      const isBlackout = isBlackoutDate(
                                        blackoutDates,
                                        startDate
                                      );
                                      const isApplicableForEntity =
                                        isPromotionApplicableForEntity(
                                          item.promotionEntity,
                                          "package",
                                          singlePackage?.packageId
                                        );

                                      const isConditionsValid =
                                        evaluateConditions(
                                          item.promotionConditions,
                                          startDate
                                        );

                                      return (
                                        isCouponCode &&
                                        isValidDate &&
                                        isBookingWithinDiscount &&
                                        isUserEligible &&
                                        !isBlackout &&
                                        isApplicableForEntity &&
                                        isConditionsValid && (
                                          <div
                                            key={index}
                                            className={`${styles.discount_card} ${selectedDiscount?.some(
                                              (discount) =>
                                                discount.id === item.id
                                            )
                                              ? styles.selectedDiscountCard
                                              : ""
                                              } w-100`}
                                          >
                                            <div className="flex justify_content_between">
                                              <div className="flex">
                                                <label
                                                  style={{
                                                    textTransform: "capitalize",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                  }}
                                                  htmlFor={item?.promotionName}
                                                >
                                                  {" "}
                                                  <input
                                                    checked={selectedDiscount?.some(
                                                      (discount) =>
                                                        discount.id === item.id
                                                    )}
                                                    onChange={() =>
                                                      handleDiscountChange(item)
                                                    }
                                                    type="radio"
                                                    id={item.promotionName}
                                                    className={`${selectedDiscount?.some(
                                                      (discount) =>
                                                        discount.id === item.id
                                                    )
                                                      ? styles.selectedDiscount_color
                                                      : ""
                                                      }`}
                                                  />
                                                  <div>
                                                    <div
                                                      className={`${styles.discount_name
                                                        } ${selectedDiscount?.some(
                                                          (discount) =>
                                                            discount.id ===
                                                            item.id
                                                        )
                                                          ? styles.selectedDiscount_color
                                                          : ""
                                                        }`}
                                                    >
                                                      {item?.promotionName?.replace(
                                                        /-/g,
                                                        " "
                                                      )}
                                                    </div>
                                                  </div>
                                                </label>
                                              </div>
                                              <div>
                                                {item?.promotionMode ===
                                                  "fixed" ? (
                                                  formatIndianCurrency(
                                                    item?.promotionAmount
                                                  )
                                                ) : (
                                                  <>{item?.promotionAmount}%</>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                          </>
                        )}

                        <div
                          className="buttons flex_direction_col"
                          style={{
                            backgroundColor: "#FDF7E4",
                            marginTop: 0,
                            padding: "0 15px",
                            paddingBottom: "10px",
                          }}
                        >
                          {Number(calculationsOfPackages?.totalAmount) > 0 ? (
                            <>
                              {!isExpired && singlePackage?.canBook && (
                                <button
                                  style={{
                                    marginTop: "10px",
                                  }}
                                  onClick={navigateToCheckOutPackage}
                                  className={styles.book_now_btn}
                                >
                                  Book Now
                                </button>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          {/* </Link> */}
                          <button
                            onClick={(e) => handleshowRatePopup(e)}
                            className={styles.get_quote_btn}
                          >
                            Book Offline
                          </button>
                        </div>
                      </div>
                    </aside>

                    {mobilePriceBreakup && (
                      <>
                        <div
                          className={`${styles.mobilePriceBreakup} ${priceBreakupPopup ? styles.open : styles.close
                            } flex justify_content_between total_amount align_items_center`}
                        >
                          <div>
                            {/* <h6 className="font_11 weight_500">Total Amt.</h6> */}
                            <span
                              className={`${styles.mobile_bottom_amt} 
                              ${Number(calculationsOfPackages?.totalAmount) <=
                                0 && "filterBlur3"
                                }`}
                              onClick={() => setPriceBreakupPopup(true)}
                            >
                              {/* {formatIndianCurrency(
                                calculationsOfPackages?.totalAmount
                              )} */}

                              {formatIndianCurrency(calculationsOfPackages?.onlyAdultCost /
                                calculationsOfPackages?.adultNumber)}{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="16"
                                viewBox="0 0 16 17"
                                fill="none"
                                style={{
                                  transform: "rotate(180deg)"
                                }}
                              >
                                <mask
                                  id="mask0_6305_6801"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="16"
                                  height="17"
                                >
                                  <rect
                                    y="16.5"
                                    width="16"
                                    height="16"
                                    transform="rotate(-90 0 16.5)"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_6305_6801)">
                                  <path
                                    d="M7.99977 10.376L13.0216 5.3542C13.154 5.22175 13.31 5.1572 13.4894 5.16053C13.669 5.16397 13.825 5.23192 13.9574 5.36436C14.0899 5.49692 14.1561 5.65292 14.1561 5.83236C14.1561 6.01181 14.0899 6.16781 13.9574 6.30036L8.8536 11.4144C8.73304 11.5349 8.59799 11.6243 8.44843 11.6824C8.29888 11.7405 8.14932 11.7695 7.99977 11.7695C7.85021 11.7695 7.70065 11.7405 7.5511 11.6824C7.40154 11.6243 7.26649 11.5349 7.14593 11.4144L2.03177 6.30036C1.89932 6.16781 1.83482 6.01009 1.83827 5.8272C1.84171 5.64431 1.90965 5.48664 2.0421 5.3542C2.17454 5.22175 2.33054 5.15553 2.5101 5.15553C2.68954 5.15553 2.84549 5.22175 2.97793 5.3542L7.99977 10.376Z"
                                    fill="#222222"
                                  />
                                </g>
                              </svg>
                              <span style={{ fontSize: '10px', color: '#222222', fontWeight: '400' }}>(more options)</span>
                            </span>
                            <span style={{ display: 'block', fontSize: '10px' }}>Per person</span>
                          </div>
                          <div
                            className={` flex flex_gap_10 align_items_center`}
                          >
                            <div>
                              {" "}
                              {/* <span
                                className={`${styles.mobile_bottom_amt} ${Number(calculationsOfPackages?.totalAmount) <=
                                  0 && "filterBlur3"
                                  }`}
                              >
                                {formatIndianCurrency(
                                  calculationsOfPackages?.totalAmount
                                )}{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                >
                                  <mask
                                    id="mask0_6305_6801"
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="16"
                                    height="17"
                                  >
                                    <rect
                                      y="16.5"
                                      width="16"
                                      height="16"
                                      transform="rotate(-90 0 16.5)"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_6305_6801)">
                                    <path
                                      d="M7.99977 10.376L13.0216 5.3542C13.154 5.22175 13.31 5.1572 13.4894 5.16053C13.669 5.16397 13.825 5.23192 13.9574 5.36436C14.0899 5.49692 14.1561 5.65292 14.1561 5.83236C14.1561 6.01181 14.0899 6.16781 13.9574 6.30036L8.8536 11.4144C8.73304 11.5349 8.59799 11.6243 8.44843 11.6824C8.29888 11.7405 8.14932 11.7695 7.99977 11.7695C7.85021 11.7695 7.70065 11.7405 7.5511 11.6824C7.40154 11.6243 7.26649 11.5349 7.14593 11.4144L2.03177 6.30036C1.89932 6.16781 1.83482 6.01009 1.83827 5.8272C1.84171 5.64431 1.90965 5.48664 2.0421 5.3542C2.17454 5.22175 2.33054 5.15553 2.5101 5.15553C2.68954 5.15553 2.84549 5.22175 2.97793 5.3542L7.99977 10.376Z"
                                      fill="#EB442D"
                                    />
                                  </g>
                                </svg>
                              </span> */}

                              {!isExpired && singlePackage?.canBook ? (
                                <button
                                  // onClick={navigateToCheckOutPackage}
                                  onClick={() => setPriceBreakupPopup(true)}
                                  className={styles.book_now_btn_mobile}
                                >
                                  Book Now
                                </button>
                              ) :
                                <button
                                  onClick={(e) => [
                                    setPriceBreakupPopup(false),
                                    handleshowRatePopup(e),
                                  ]}
                                  className={styles.book_now_btn_mobile}
                                >
                                  BOOK OFFLINE
                                </button>
                              }
                            </div>
                          </div>
                        </div>
                        {priceBreakupPopup && (
                          <div className="bg_back_drop_overlay">
                            <div
                              className="common_background common_background_parent_sticky"
                              id="PriceBreak"
                              style={{ overflow: "scroll" }}
                            >
                              <div className="flex justify_content_end p_b_10 ">
                                <svg
                                  onClick={() => setPriceBreakupPopup(false)}
                                  width="14"
                                  height="13"
                                  viewBox="0 0 14 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1 12.5L13 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                  <path
                                    d="M13 12.5L1 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                </svg>
                              </div>

                              {singlePackage &&
                                singlePackage?.packageRates &&
                                singlePackage?.packageRates.length > 0 && (
                                  <div
                                    style={{
                                      marginBottom: "5px",
                                      border: "0.5px solid #ccc",
                                    }}
                                  >
                                    <label>Select Accommodation</label>
                                    <select
                                      className="w-full"
                                      name="meal_plan"
                                      value={selectedCategory}
                                      onChange={(e) =>
                                        setSelectedCategory(e.target.value)
                                      }
                                    >
                                      <option value="">Select an option</option>
                                      {allCategories.map((category) => (
                                        <option
                                          key={category?.value}
                                          value={category?.value}
                                        >
                                          {category?.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}

                              {singlePackage &&
                                singlePackage?.packageRates &&
                                singlePackage?.packageRates.length > 0 && (
                                  <div>
                                    <label>Select Meal Plan</label>
                                    <select
                                      className="w-full"
                                      name="meal_plan"
                                      value={selectedMealPlan}
                                      onChange={(e) =>
                                        setSelectedMealPlan(e.target.value)
                                      }
                                    >
                                      <option value="" disabled>
                                        Select an option
                                      </option>
                                      {Array.from(
                                        new Set(
                                          singlePackage?.packageRates.map(
                                            (rate) => rate.mealPlan
                                          )
                                        )
                                      ).map((mealPlan) => (
                                        <option key={mealPlan} value={mealPlan}>
                                          {mapMealPlan[mealPlan?.toUpperCase()]}
                                          {/* {mealPlan.toUpperCase()} */}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}

                              {singlePackage?.packageAddons &&
                                singlePackage?.packageAddons.length > 0 && (
                                  <div className={`${styles.addons_container}`}>
                                    <div
                                      className="flex align_items_center justify_content_between"
                                      onClick={toggleAccordionAddon}
                                    >
                                      <h5 style={{ color: "#333" }}>Addons</h5>
                                      <svg
                                        width="25px"
                                        height="25px"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{
                                          cursor: "pointer",
                                          transform: isExpandedAddon
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.3s ease",
                                        }}
                                      >
                                        <path
                                          d="M7 10L12 15L17 10"
                                          stroke="#016937"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>

                                    <div
                                      className="overflow-width"
                                      style={{
                                        display: isExpandedAddon
                                          ? "block"
                                          : "none",
                                      }}
                                    >
                                      {singlePackage.packageAddons
                                        .filter(
                                          (item) =>
                                            !item.detail.includes("Volvo") &&
                                            item.addonType !== "ticket"
                                        )
                                        .map((item, index) => {
                                          let finalAddonPrice = item?.price;
                                          let priceWithMarkup = item?.price;

                                          if (markupData) {
                                            const markup = markupData;
                                            if (
                                              markup.markupType === "percentage"
                                            ) {
                                              finalAddonPrice +=
                                                (item.price *
                                                  parseFloat(markup.amount)) /
                                                100;
                                            } else if (
                                              markup.markupType === "fixed"
                                            ) {
                                              finalAddonPrice += parseFloat(
                                                markup.amount
                                              );
                                            }
                                          }
                                          priceWithMarkup = finalAddonPrice;

                                          if (
                                            commission?.commissionAmount &&
                                            commission?.commissionType
                                          ) {
                                            if (
                                              commission?.commissionType ===
                                              "percentage"
                                            ) {
                                              finalAddonPrice -=
                                                (Number(finalAddonPrice) *
                                                  Number(
                                                    commission?.commissionAmount
                                                  )) /
                                                100;
                                            } else if (
                                              commission?.commissionType ===
                                              "fixed"
                                            ) {
                                              finalAddonPrice = Number(
                                                commission?.commissionAmount
                                              );
                                            }
                                          }

                                          return (
                                            <div
                                              key={index}
                                              className={`${styles.addon_inner_card
                                                } ${selectedAddOns.some(
                                                  (addon) =>
                                                    addon.id === item.id
                                                )
                                                  ? styles.selected
                                                  : ""
                                                } flex justify_content_between w-100 mt-7`}
                                            >
                                              <div
                                                style={{
                                                  cursor: "pointer",
                                                  width: "80%",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    fontSize: "15px",
                                                    fontWeight: 500,
                                                  }}
                                                >
                                                  <span className="font_12">
                                                    {item.detail}
                                                  </span>{" "}
                                                  {commission?.commissionAmount &&
                                                    commission?.commissionType && (
                                                      <span
                                                        className={`${selectedAddOns.some(
                                                          (addon) =>
                                                            addon.id ===
                                                            item.id
                                                        )
                                                          ? styles.selected_price
                                                          : ""
                                                          }`}
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "red",
                                                          textDecoration:
                                                            "line-through",
                                                        }}
                                                      >
                                                        {formatIndianCurrency(
                                                          priceWithMarkup
                                                        )}{" "}
                                                        {item.perPerson
                                                          ? `* ${guest}`
                                                          : ""}
                                                      </span>
                                                    )}
                                                  <span
                                                    className={`${styles.addon_price
                                                      } ${selectedAddOns.some(
                                                        (addon) =>
                                                          addon.id === item.id
                                                      )
                                                        ? styles.selected_price
                                                        : ""
                                                      }`}
                                                  >
                                                    {formatIndianCurrency(
                                                      finalAddonPrice
                                                    )}{" "}
                                                    {item.perPerson
                                                      ? `* ${guest}`
                                                      : ""}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="">
                                                <button
                                                  style={{ fontSize: "10px" }}
                                                  onClick={() =>
                                                    handleSelectedAddOns({
                                                      ...item,
                                                      finalAddonPrice,
                                                      priceWithMarkup,
                                                    })
                                                  }
                                                >
                                                  {selectedAddOns.some(
                                                    (addon) =>
                                                      addon.id === item.id
                                                  ) ? (
                                                    <div
                                                      style={{ color: "red" }}
                                                    >
                                                      <CrossWithBorder />
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{
                                                        background: "#009A50",
                                                        color: "#fff",
                                                        padding: "5px 7px",
                                                      }}
                                                    >
                                                      ADD
                                                    </div>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>
                                  </div>
                                )}

                              <div
                                className="flex justify_content_between align_items_center"
                                onClick={() => [
                                  togglePaymentDetails(),
                                  handleButtonClick(),
                                ]}
                              >
                                <h4
                                  style={{
                                    fontSize: "16px",
                                    padding: "10px 0",
                                    fontWeight: "500",
                                  }}
                                >
                                  Price Breakup
                                </h4>
                                <div>
                                  <button
                                    className={`${activePayment === "priceSummary" ? "" : ""
                                      }`}
                                  >
                                    {/* <svg
                                      width="13"
                                      height="8"
                                      viewBox="0 0 13 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transition: "transform 0.3s",
                                        transform: paymentDetails
                                          ? "rotate(0deg)"
                                          : "rotate(180deg)",
                                      }}
                                    >
                                      <path
                                        d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                        stroke="#222222"
                                        strokeWidth="1.5"
                                      />
                                    </svg> */}

                                    {paymentDetails ? (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                      >
                                        <mask
                                          id="mask0_6868_15102"
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="18"
                                          height="19"
                                        >
                                          <rect
                                            y="0.5"
                                            width="18"
                                            height="18"
                                            fill="#D9D9D9"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_6868_15102)">
                                          <path
                                            d="M4.38462 14.1154H7.38462C7.58077 14.1154 7.74523 14.1818 7.878 14.3145C8.01062 14.4473 8.07692 14.6118 8.07692 14.8079C8.07692 15.0042 8.01062 15.1686 7.878 15.3011C7.74523 15.4337 7.58077 15.5 7.38462 15.5H3.83446C3.598 15.5 3.39985 15.42 3.24 15.26C3.08 15.1002 3 14.902 3 14.6655V11.1154C3 10.9192 3.06638 10.7548 3.19915 10.622C3.33192 10.4894 3.49638 10.4231 3.69254 10.4231C3.88885 10.4231 4.05323 10.4894 4.18569 10.622C4.31831 10.7548 4.38462 10.9192 4.38462 11.1154V14.1154ZM13.6154 4.88462H10.6154C10.4192 4.88462 10.2548 4.81823 10.122 4.68546C9.98938 4.55269 9.92308 4.38823 9.92308 4.19208C9.92308 3.99577 9.98938 3.83138 10.122 3.69892C10.2548 3.56631 10.4192 3.5 10.6154 3.5H14.1655C14.402 3.5 14.6002 3.58 14.76 3.74C14.92 3.89985 15 4.098 15 4.33446V7.88462C15 8.08077 14.9336 8.24523 14.8008 8.378C14.6681 8.51062 14.5036 8.57692 14.3075 8.57692C14.1112 8.57692 13.9468 8.51062 13.8143 8.378C13.6817 8.24523 13.6154 8.08077 13.6154 7.88462V4.88462Z"
                                            fill="#1C1B1F"
                                          />
                                        </g>
                                      </svg>
                                    ) : (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                      >
                                        <mask
                                          id="mask0_6868_15096"
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="18"
                                          height="19"
                                        >
                                          <rect
                                            y="0.5"
                                            width="18"
                                            height="18"
                                            fill="#D9D9D9"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_6868_15096)">
                                          <path
                                            d="M6.69231 11.8077H3.69231C3.49615 11.8077 3.33177 11.7413 3.19915 11.6085C3.06638 11.4758 3 11.3113 3 11.1152C3 10.9188 3.06638 10.7545 3.19915 10.622C3.33177 10.4894 3.49615 10.4231 3.69231 10.4231H7.24269C7.479 10.4231 7.67715 10.503 7.83715 10.6628C7.997 10.8228 8.07692 11.021 8.07692 11.2573V14.8077C8.07692 15.0038 8.01054 15.1682 7.87777 15.3008C7.745 15.4336 7.58054 15.5 7.38438 15.5C7.18808 15.5 7.02369 15.4336 6.89123 15.3008C6.75862 15.1682 6.69231 15.0038 6.69231 14.8077V11.8077ZM11.3077 7.19231H14.3077C14.5038 7.19231 14.6682 7.25869 14.8008 7.39146C14.9336 7.52423 15 7.68869 15 7.88485C15 8.08115 14.9336 8.24554 14.8008 8.378C14.6682 8.51062 14.5038 8.57692 14.3077 8.57692H10.7573C10.521 8.57692 10.3228 8.497 10.1628 8.33715C10.003 8.17715 9.92308 7.979 9.92308 7.74269V4.19231C9.92308 3.99615 9.98946 3.83177 10.1222 3.69915C10.255 3.56638 10.4195 3.5 10.6156 3.5C10.8119 3.5 10.9763 3.56638 11.1088 3.69915C11.2414 3.83177 11.3077 3.99615 11.3077 4.19231V7.19231Z"
                                            fill="#1C1B1F"
                                          />
                                        </g>
                                      </svg>
                                    )}
                                  </button>
                                </div>
                              </div>
                              <div>
                                {/* {activePayment === "priceSummary" && ( */}
                                <>
                                  {activePayment === "priceSummary" && (
                                    <>
                                      <div className="flex justify_content_between mt-7">
                                        <p>
                                          Adult Cost{" "}
                                          <small>
                                            {" "}
                                            (
                                            {calculationsOfPackages?.onlyAdultCost /
                                              calculationsOfPackages?.adultNumber}{" "}
                                            X{" "}
                                            {
                                              calculationsOfPackages?.adultNumber
                                            }
                                            )
                                          </small>
                                        </p>
                                        <span
                                          className={`room_text-right ${Number(
                                            calculationsOfPackages?.onlyAdultCost
                                          ) <= 0 && "filterBlur3"
                                            }`}
                                        >
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <>
                                              {formatIndianCurrency(
                                                calculationsOfPackages?.onlyAdultCost
                                              )}
                                            </>
                                          )}
                                        </span>
                                      </div>

                                      {calculationsOfPackages?.extraAdultNumber >
                                        0 &&
                                        calculationsOfPackages?.ExtraAdultCost ? (
                                        <div className="flex justify_content_between mt-7">
                                          <p>
                                            Extra Adult Cost{" "}
                                            <small>
                                              {" "}
                                              (
                                              {calculationsOfPackages?.ExtraAdultCost /
                                                calculationsOfPackages?.extraAdultNumber}{" "}
                                              X{" "}
                                              {
                                                calculationsOfPackages?.extraAdultNumber
                                              }
                                              )
                                            </small>
                                          </p>
                                          <span
                                            className={`room_text-right ${Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                              }`}
                                          >
                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.ExtraAdultCost
                                                )}
                                              </>
                                            )}
                                            {/* {formatIndianCurrency(Number(calculationsOfPackages?.ExtraAdultCost) + Number(calculationsOfPackages?.basePrice))} */}
                                          </span>
                                        </div>
                                      ) : null}

                                      {under6AgeChildren?.length > 0 &&
                                        calculationsOfPackages?.childNumber > 0 &&
                                        calculationsOfPackages?.childCostWithOutBed ? (
                                        <div className="flex justify_content_between mt-7">
                                          <p>
                                            Child Cost
                                            {/* ({`< 6 yrs`}){" "} */}
                                            {/* <small>
                                              {" "}
                                              {Math.round(
                                                calculationsOfPackages?.childCostWithOutBed /
                                                under6AgeChildren.length
                                              )}
                                              X {under6AgeChildren.length})
                                            </small> */}
                                          </p>
                                          <span
                                            className={`room_text-right ${Number(
                                              calculationsOfPackages?.childCostWithOutBed
                                            ) <= 0 && "filterBlur3"
                                              }`}
                                          >
                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.childCostWithOutBed
                                                )}
                                              </>
                                            )}
                                          </span>
                                        </div>
                                      ) : null}

                                      {
                                        // over6AgeChildren?.length > 0 &&
                                        calculationsOfPackages?.childNumber >
                                          0 && newChildAge?.length > 0 ? (
                                          // calculationsOfPackages?.childCostWithBed ? es?.childCostWithBed ?
                                          <div
                                            className="flex justify_content_between mt-7"
                                            onClick={() =>
                                              setShowChildBreakUpPopup(
                                                !showChildBreakUpPopup
                                              )
                                            }
                                          >
                                            <p>
                                              Child Cost
                                              <button>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="17"
                                                  viewBox="0 0 16 17"
                                                  fill="none"
                                                  style={{
                                                    transition:
                                                      "transform 0.5s",
                                                    transform:
                                                      showChildBreakUpPopup
                                                        ? "rotate(180deg)"
                                                        : "rotate(0deg)",
                                                  }}
                                                >
                                                  <mask
                                                    id="mask0_7293_4207"
                                                    maskUnits="userSpaceOnUse"
                                                    x="0"
                                                    y="0"
                                                    width="16"
                                                    height="17"
                                                  >
                                                    <rect
                                                      y="16.5"
                                                      width="16"
                                                      height="16"
                                                      transform="rotate(-90 0 16.5)"
                                                      fill="#D9D9D9"
                                                    />
                                                  </mask>
                                                  <g mask="url(#mask0_7293_4207)">
                                                    <path
                                                      d="M7.99998 10.6204L13.1436 5.47694C13.2419 5.37861 13.3594 5.33005 13.4961 5.33128C13.6329 5.33261 13.7504 5.38244 13.8486 5.48078C13.947 5.579 13.9961 5.6965 13.9961 5.83328C13.9961 5.97005 13.947 6.08755 13.8486 6.18578L8.75765 11.2808C8.64998 11.3884 8.52993 11.4671 8.39748 11.5166C8.26493 11.5662 8.13242 11.5909 7.99998 11.5909C7.86754 11.5909 7.73504 11.5662 7.60248 11.5166C7.47004 11.4671 7.34998 11.3884 7.24231 11.2808L2.14748 6.18578C2.04915 6.08755 2.00065 5.96939 2.00198 5.83128C2.0032 5.69328 2.05298 5.57516 2.15131 5.47694C2.24954 5.37861 2.36704 5.32944 2.50381 5.32944C2.64059 5.32944 2.75809 5.37861 2.85631 5.47694L7.99998 10.6204Z"
                                                      fill="#1C1B1F"
                                                    />
                                                  </g>
                                                </svg>
                                              </button>
                                              {/* ({`>= 6 yrs`}){" "} */}
                                              {/* <small>
                                              ̀ (
                                              {calculationsOfPackages?.childCostWithBed /
                                                over6AgeChildren.length}{" "}
                                              X {over6AgeChildren.length})
                                            </small> */}
                                            </p>
                                            <span
                                              className={`room_text-right ${Number(
                                                calculationsOfPackages?.childCostWithBed
                                              ) <= 0 && "filterBlur3"
                                                }`}
                                            >
                                              {priceLoader ? (
                                                <Skeleton
                                                  width={80}
                                                  height={10}
                                                  borderRadius={4}
                                                />
                                              ) : (
                                                <>
                                                  {formatIndianCurrency(
                                                    calculationsOfPackages?.childCostWithBed
                                                  )}
                                                </>
                                              )}
                                            </span>
                                          </div>
                                        ) : null
                                      }

                                      {showChildBreakUpPopup && (
                                        <>
                                          {newChildAge &&
                                            newChildAge?.length > 0 ? (
                                            <>
                                              {newChildAge.map(
                                                (item, childIndex) => (
                                                  <div
                                                    className="flex justify_content_between mt-7"
                                                    key={childIndex}
                                                  >
                                                    <p>
                                                      Child {childIndex + 1}{" "}
                                                      <small>
                                                        ({item?.age} years)
                                                      </small>
                                                    </p>
                                                    <span>
                                                      {item?.type ===
                                                        "complimentary"
                                                        ? "Complimentary"
                                                        : item?.type ===
                                                          "withbed"
                                                          ? "With Bed"
                                                          : "Without Bed"}

                                                      {item?.type ===
                                                        "complimentary" && (
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="14"
                                                            height="15"
                                                            viewBox="0 0 14 15"
                                                            fill="none"
                                                            style={{
                                                              marginLeft: "5px",
                                                              marginRight: "0",
                                                            }}
                                                          >
                                                            <path
                                                              d="M7.23677 2L7.62744 2.03349C10.0613 2.30369 12.0579 4.21784 12.4328 6.6365C12.991 10.2387 9.99351 13.3663 6.37368 12.9652C3.85393 12.686 1.81434 10.6468 1.53556 8.12637L1.50206 7.73571C1.50685 7.57866 1.49559 7.41992 1.50206 7.26315C1.61873 4.45834 3.91135 2.13003 6.72128 2H7.23677ZM7.24747 6.54348H5.02451L5.40575 5.97424H7.18301C7.09098 5.77399 6.93688 5.61652 6.73578 5.52462C6.48317 5.40923 6.20551 5.39375 5.93235 5.37222L5.02451 5.3725L5.40575 4.8034H9.1376L8.77241 5.37264H7.77365C7.91086 5.54798 8.02035 5.75021 8.05286 5.9741H9.13746L8.77016 6.54109L8.08101 6.54475L7.98841 6.8656L11.3282 6.09217C10.8462 4.56248 9.52657 3.37869 7.95815 3.04517C5.18199 2.45497 2.57625 4.49915 2.44664 7.311V7.67703L2.49012 8.13312L7.07282 7.07303C7.1885 6.92611 7.25408 6.73135 7.24747 6.54348ZM8.39652 10.8721H7.42465L5.25629 8.16436L5.22829 8.09006L2.60791 8.69166C3.05163 10.3835 4.49213 11.6876 6.21438 11.9856C9.24301 12.5098 11.8894 9.96988 11.5201 6.92597C11.5109 6.84956 11.4972 6.73951 11.4783 6.66704C11.4751 6.65479 11.4866 6.64748 11.4624 6.65043L7.48108 7.56656C7.08676 7.85364 6.61897 8.01238 6.1305 8.03644L8.39652 10.8721Z"
                                                              fill="#EB442D"
                                                            />
                                                          </svg>
                                                        )}
                                                      {item?.age >= 6 && (
                                                        <button
                                                          className="pointer tooltip"
                                                          onClick={() =>
                                                            handleTypeChange(
                                                              childIndex
                                                            )
                                                          }
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="14"
                                                            height="14"
                                                            viewBox="0 0 14 14"
                                                            fill="none"
                                                            style={{
                                                              marginLeft: "5px",
                                                              marginRight: "0",
                                                            }}
                                                          >
                                                            <mask
                                                              id="mask0_7293_4275"
                                                              maskUnits="userSpaceOnUse"
                                                              x="0"
                                                              y="0"
                                                              width="14"
                                                              height="14"
                                                            >
                                                              <rect
                                                                width="14"
                                                                height="14"
                                                                fill="#D9D9D9"
                                                              />
                                                            </mask>
                                                            <g mask="url(#mask0_7293_4275)">
                                                              <path
                                                                d="M5.34455 7.37578C5.22049 7.37578 5.11656 7.33383 5.03276 7.24993C4.94905 7.16613 4.90719 7.06224 4.90719 6.93828V3.12868L3.55546 4.48041C3.47652 4.5612 3.37789 4.6016 3.25957 4.6016C3.14125 4.6016 3.03683 4.55974 2.94632 4.47603C2.8558 4.38474 2.81055 4.28038 2.81055 4.16293C2.81055 4.04558 2.8558 3.94165 2.94632 3.85114L4.97005 1.82741C5.02459 1.77277 5.08239 1.73427 5.14344 1.71191C5.2046 1.68945 5.27007 1.67822 5.33988 1.67822C5.40969 1.67822 5.47599 1.6895 5.5388 1.71206C5.6016 1.73471 5.65994 1.77316 5.7138 1.82741L7.75211 3.86572C7.83883 3.95245 7.88161 4.05302 7.88044 4.16745C7.87937 4.28188 7.83358 4.38474 7.74307 4.47603C7.65255 4.55974 7.55008 4.6031 7.43565 4.60612C7.32122 4.60903 7.2188 4.56528 7.12838 4.47487L5.78219 3.12868V6.94383C5.78219 7.06623 5.74024 7.1688 5.65634 7.25154C5.57244 7.33437 5.46851 7.37578 5.34455 7.37578ZM8.65876 12.3162C8.58895 12.3162 8.52264 12.3049 8.45984 12.2822C8.39703 12.2596 8.3387 12.2212 8.28484 12.167L6.24653 10.1287C6.1598 10.0419 6.11703 9.94129 6.11819 9.82695C6.11926 9.71252 6.16505 9.60966 6.25557 9.51837C6.34608 9.43466 6.44855 9.3913 6.56298 9.38829C6.67742 9.38527 6.77984 9.42902 6.87026 9.51953L8.21644 10.8657V7.05043C8.21644 6.92813 8.25839 6.82556 8.3423 6.74272C8.4262 6.65999 8.53013 6.61862 8.65409 6.61862C8.77814 6.61862 8.88207 6.66052 8.96588 6.74433C9.04959 6.82823 9.09144 6.93216 9.09144 7.05612V10.8657L10.4432 9.51385C10.5221 9.43315 10.6207 9.39281 10.7391 9.39281C10.8574 9.39281 10.9618 9.43466 11.0523 9.51837C11.1428 9.60966 11.1881 9.71398 11.1881 9.83133C11.1881 9.94877 11.1428 10.0528 11.0523 10.1433L9.02859 12.167C8.97405 12.2215 8.91625 12.26 8.85519 12.2825C8.79404 12.305 8.72856 12.3162 8.65876 12.3162Z"
                                                                fill="#EB442D"
                                                              />
                                                            </g>
                                                          </svg>

                                                          <span
                                                            className="tooltip_text"
                                                            style={{
                                                              right: "0",
                                                              left: "auto",
                                                              fontSize: "12px",
                                                              width: "100px",
                                                            }}
                                                          >
                                                            Switch to another
                                                            option
                                                          </span>
                                                        </button>
                                                      )}
                                                    </span>
                                                  </div>
                                                )
                                              )}
                                            </>
                                          ) : null}
                                        </>
                                      )}
                                    </>
                                  )}

                                  <div className="flex justify_content_between mt-7">
                                    <h6>Total Package Cost</h6>
                                    <h6
                                      className={`room_text-right alert_text ${Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                        }`}
                                    >
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.basePrice
                                          )}
                                        </>
                                      )}
                                    </h6>
                                  </div>

                                  {activePayment === "priceSummary" && (
                                    <>
                                      {(selectedAutomaticDiscount?.length > 0 ||
                                        selectedDiscount?.length > 0) && (
                                          <div
                                            className="mt-7 pt_10"
                                            style={{
                                              borderTop: "0.5px solid #ccc",
                                            }}
                                          >
                                            <p>
                                              <b>
                                                Package Discount
                                                {selectedAutomaticDiscount?.length >
                                                  1
                                                  ? "s"
                                                  : ""}
                                              </b>
                                            </p>
                                            {selectedAutomaticDiscount?.map(
                                              (discount, index) => (
                                                <div
                                                  className="flex justify_content_between mt-2"
                                                  key={discount.id}
                                                >
                                                  <span className="discount-name">
                                                    {discount.promotionName}
                                                  </span>
                                                  <span className="room_text-right green">
                                                    {discount.promotionMode ===
                                                      "percentage"
                                                      ? `${+discount.promotionAmount}%`
                                                      : `${formatIndianCurrency(
                                                        discount.promotionAmount
                                                      )}`}
                                                  </span>
                                                </div>
                                              )
                                            )}

                                            {selectedDiscount &&
                                              selectedDiscount?.length > 0 &&
                                              selectedDiscount?.map(
                                                (discount, index) => (
                                                  <div
                                                    className="flex justify_content_between mt-2"
                                                    key={discount.id}
                                                  >
                                                    <span className="discount-name">
                                                      {discount.promotionName}
                                                    </span>
                                                    <span className="room_text-right green">
                                                      {discount.promotionMode ===
                                                        "percentage"
                                                        ? `${+discount.promotionAmount}%`
                                                        : `${formatIndianCurrency(
                                                          discount.promotionAmount
                                                        )}`}
                                                    </span>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        )}

                                      {calculationsOfPackages?.discount > 0 && (
                                        <div
                                          className="flex justify_content_between mt-7 border-bottom-one "
                                          style={{ paddingBottom: "7px" }}
                                        >
                                          <p>Package Cost (After Disc.)</p>
                                          <span
                                            className={`room_text-right ${Number(
                                              calculationsOfPackages?.totalAmount
                                            ) <= 0 && "filterBlur3"
                                              }`}
                                          >
                                            {priceLoader ? (
                                              <Skeleton
                                                width={80}
                                                height={10}
                                                borderRadius={4}
                                              />
                                            ) : (
                                              <>
                                                {formatIndianCurrency(
                                                  calculationsOfPackages?.priceAfterDiscount
                                                )}
                                              </>
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {commission &&
                                        Object.keys(commission)?.length > 0 && (
                                          <>
                                            <div className="flex justify_content_between mt-7">
                                              <p>
                                                Commission{" "}
                                                <small>
                                                  ({" "}
                                                  {commission.commissionType ===
                                                    "fixed" ? (
                                                    <span className="room_text-right">
                                                      {formatIndianCurrency(
                                                        commission?.commissionAmount
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span className="room_text-right">
                                                      {
                                                        commission?.commissionAmount
                                                      }
                                                      %
                                                    </span>
                                                  )}
                                                  )
                                                </small>
                                              </p>

                                              {formatIndianCurrency(
                                                calculationsOfPackages?.calculatedCommissionAmount
                                              )}
                                            </div>
                                          </>
                                        )}

                                      {selectedAddOns &&
                                        selectedAddOns?.length > 0 && (
                                          <div className="flex justify_content_between mt-7">
                                            <p>Addons Price</p>
                                            <span
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "end",
                                              }}
                                            >
                                              {commission &&
                                                Object.keys(commission)
                                                  ?.length > 0 && (
                                                  <small
                                                    style={{
                                                      color: "red",
                                                      textDecoration:
                                                        "line-through",
                                                    }}
                                                  >
                                                    {formatIndianCurrency(
                                                      totalAddonsCostWithoutCommission
                                                    )}
                                                  </small>
                                                )}
                                              <b>
                                                {formatIndianCurrency(
                                                  totalAddonsCost
                                                )}
                                              </b>
                                            </span>
                                          </div>
                                        )}

                                      <div className="flex justify_content_between mt-7">
                                        <p>Subtotal </p>
                                        <span>
                                          {priceLoader ? (
                                            <Skeleton
                                              width={80}
                                              height={10}
                                              borderRadius={4}
                                            />
                                          ) : (
                                            <>
                                              {formatIndianCurrency(
                                                calculationsOfPackages?.subtotal
                                              )}
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    </>
                                  )}

                                  <div
                                    className="flex justify_content_between mt-7 border-bottom-one "
                                    style={{ paddingBottom: "7px" }}
                                  >
                                    <p>GST(5%) </p>
                                    <span
                                      className={`room_text-right  ${Number(
                                        calculationsOfPackages?.totalAmount
                                      ) <= 0 && "filterBlur3"
                                        }`}
                                    >
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.taxAmount
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </div>

                                  {/* {commission && Object.keys(commission).length > 0 && calculationsOfPackages?.calculatedCommissionAmount && (
                                              <>
                                                <div className="flex justify_content_between mt-7">
                                                  <p>
                                                    Your Savings
                                                  </p>
                                                  <span className="room_text-right">
                                                    {formatIndianCurrency(
                                                      calculationsOfPackages?.calculatedCommissionAmount
                                                    )}
                                                  </span>
                                                </div>
                                              </>
                                            )} */}
                                  <div
                                    className="flex justify_content_between mt-7 border-bottom-one "
                                    style={{ paddingBottom: "7px" }}
                                  >
                                    <p>Vehicle</p>
                                    <span className="room_text-right">
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <span
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          <strong>
                                            {ratesOfPackages?.VehicleType?.replace(
                                              /-/g,
                                              " "
                                            )}
                                          </strong>
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                  <div className="flex justify_content_between mt-7 pt_10">
                                    <h6>
                                      <b>Total Amount to be paid</b>
                                    </h6>
                                    <h6>
                                      <span
                                        className={` ${Number(
                                          calculationsOfPackages?.totalAmount
                                        ) <= 0 && "filterBlur3"
                                          }`}
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "end",
                                        }}
                                      >
                                        {/* {commission && Object.keys(commission).length > 0 && calculationsOfPackages?.calculatedCommissionAmount && (
                                                    <small style={{ color: 'red', textDecoration: 'line-through' }}>
                                                      {formatIndianCurrency(
                                                        Number(calculationsOfPackages?.calculatedCommissionAmount) + Number(calculationsOfPackages?.totalAmount)
                                                      )}
                                                    </small>
                                                  )} */}
                                        {priceLoader ? (
                                          <Skeleton
                                            width={80}
                                            height={10}
                                            borderRadius={4}
                                          />
                                        ) : (
                                          <>
                                            {" "}
                                            {formatIndianCurrency(
                                              calculationsOfPackages?.totalAmount
                                            )}
                                          </>
                                        )}
                                      </span>
                                    </h6>
                                  </div>
                                  {/* <div className="flex justify_content_between mt-7">
                        <h6>
                          <b>
                            Per Pax Cost{" "}
                            <small>({calculationsOfPackages?.perPaxCount})</small>
                          </b>
                        </h6>
                        <h6>
                          <b>
                            {" "}
                            {formatIndianCurrency(
                              calculationsOfPackages?.perPaxCost
                            )}
                          </b>
                        </h6>
                      </div>{" "} */}
                                </>
                                {/* )} */}
                              </div>

                              <div className="buttons flex_direction_col">
                                {/* <Link to={"/checkout-package"}> */}
                                {Number(calculationsOfPackages?.totalAmount) >
                                  0 ? (
                                  <></>
                                ) : (
                                  <>
                                    {singlePackage?.canCustomise && (
                                      <button
                                        onClick={navigateToCustomizePackage}
                                        className="common_btn_disabled"
                                      >
                                        Customize
                                      </button>
                                    )}
                                  </>
                                )}
                                {/* </Link> */}
                                <div>
                                  {" "}
                                  <button
                                    // style={{
                                    //   background: "white",
                                    //   color: "#016937",
                                    // }}
                                    onClick={navigateToCheckOutPackage}
                                    className={styles.book_now_mobile}
                                  >
                                    <b> Book Now</b>
                                  </button>
                                </div>
                                <button
                                  onClick={(e) => [
                                    setPriceBreakupPopup(false),
                                    handleshowRatePopup(e),
                                  ]}
                                  className={styles.get_quote_btn}
                                >
                                  Book Offline
                                </button>
                              </div>

                              {promotions.length > 0 && (
                                <>
                                  {promotions.some(
                                    (item) =>
                                      item.promotionType === "coupon" &&
                                      (() => {
                                        const isValidDate = checkDates(
                                          item.startDate,
                                          item.endDate
                                        );
                                        const isBookingWithinDiscount =
                                          checkBookingDates(
                                            startDate,
                                            startDate,
                                            item.startDate,
                                            item.endDate
                                          );
                                        const isUserEligible =
                                          isPromotionApplicable(
                                            userType === "customer"
                                              ? "customers"
                                              : userType === "agent"
                                                ? "agents"
                                                : "",
                                            userDetails?.id,
                                            item.promotionApplicable
                                          );
                                        const blackoutDates =
                                          item.promotionBlackOutDate || [];
                                        const isBlackout = isBlackoutDate(
                                          blackoutDates,
                                          startDate
                                        );
                                        const isApplicableForEntity =
                                          isPromotionApplicableForEntity(
                                            item.promotionEntity,
                                            "package",
                                            singlePackage?.packageId
                                          );
                                        const isConditionsValid =
                                          evaluateConditions(
                                            item.promotionConditions,
                                            startDate
                                          );

                                        return (
                                          isValidDate &&
                                          isBookingWithinDiscount &&
                                          isUserEligible &&
                                          !isBlackout &&
                                          isApplicableForEntity &&
                                          isConditionsValid
                                        );
                                      })()
                                  ) && (
                                      <div
                                        className="common_background"
                                        style={{ marginTop: "10px" }}
                                      >
                                        <div className="flex justify_content_between cursor_pointer">
                                          <div className="flex justify_content_between w-100">
                                            <div>
                                              <h5 className="text-left">
                                                Discounts
                                              </h5>
                                            </div>
                                            {selectedDiscount && (
                                              <button
                                                className="view_btn"
                                                onClick={() =>
                                                  setSelectedDiscount(null)
                                                }
                                              >
                                                clear
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                        <div>
                                          {promotions
                                            .filter(
                                              (item) =>
                                                item.promotionType === "coupon"
                                            )
                                            .map((item, index) => {
                                              const isValidDate = checkDates(
                                                item.startDate,
                                                item.endDate
                                              );
                                              const isBookingWithinDiscount =
                                                checkBookingDates(
                                                  startDate,
                                                  startDate,
                                                  item.startDate,
                                                  item.endDate
                                                );
                                              const isUserEligible =
                                                isPromotionApplicable(
                                                  userType === "customer"
                                                    ? "customers"
                                                    : userType === "agent"
                                                      ? "agents"
                                                      : "",
                                                  userDetails?.id,
                                                  item.promotionApplicable
                                                );
                                              const blackoutDates =
                                                item.promotionBlackOutDate || [];
                                              const isBlackout = isBlackoutDate(
                                                blackoutDates,
                                                startDate
                                              );
                                              const isApplicableForEntity =
                                                isPromotionApplicableForEntity(
                                                  item.promotionEntity,
                                                  "package",
                                                  singlePackage?.packageId
                                                );
                                              const isConditionsValid =
                                                evaluateConditions(
                                                  item.promotionConditions,
                                                  startDate
                                                );

                                              return (
                                                isValidDate &&
                                                isBookingWithinDiscount &&
                                                isUserEligible &&
                                                !isBlackout &&
                                                isApplicableForEntity &&
                                                isConditionsValid && (
                                                  <div
                                                    key={index}
                                                    className="flex discountSingleDiv justify_content_between w-100"
                                                  >
                                                    <div className="flex">
                                                      <label
                                                        style={{
                                                          textTransform:
                                                            "capitalize",
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          alignItems: "center",
                                                        }}
                                                        htmlFor={
                                                          item?.promotionName
                                                        }
                                                      >
                                                        <input
                                                          checked={
                                                            selectedDiscount?.id ===
                                                            item?.id
                                                          }
                                                          onChange={() =>
                                                            handleDiscountChange(
                                                              item
                                                            )
                                                          }
                                                          type="radio"
                                                          id={item?.promotionName}
                                                        />
                                                        <div>
                                                          <div>
                                                            {item?.promotionName?.replace(
                                                              /-/g,
                                                              " "
                                                            )}
                                                          </div>
                                                        </div>
                                                      </label>
                                                    </div>
                                                    <div>
                                                      {item?.promotionMode ===
                                                        "fixed" ? (
                                                        formatIndianCurrency(
                                                          item?.promotionAmount
                                                        )
                                                      ) : (
                                                        <>
                                                          {item?.promotionAmount}%
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              );
                                            })}
                                        </div>
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </div>
                        )}

                        {/* <aside>
                        <OurQuery />
                        <ChooseUs className="mt-20" />
                        <SendItinerary singlePackage={singlePackage} />
                      </aside> */}
                      </>
                    )}

                    {showRatePopup && (
                      <PackageQueryForm
                        package_id={singlePackage?.packageId}
                        setshowRatePopup={setshowRatePopup}
                        typeDetail="package"
                        packageData={singlePackage}
                        guest={guest}
                        selectedCategory={selectedCategory}
                        children={children}
                        childAge={childAge}
                      />
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      {/* <NewCustomSliderTaxi
        onClose={() => setShowVehicleSlider(false)}
        setIsSliderOpen={setShowVehicleSlider}
        setCustomizableRatesLoader={setCustomizableRatesLoader}
        allVehicles={[]}
      changeSelectedVehicle={changeSelectedVehicle}
      setIsVehicleCustomizedClick={setIsVehicleCustomizedClick}
      fetchTransportCost={fetchTransportCost}
      calculateDataDayByDay={calculateDataDayByDay}
      fetchCostOfVehicle={fetchCostOfVehicle}
      vehicleDetails={vehicleDetails}
      changeSelectedActivity={changeSelectedActivity}
      setOldVehicleCost={setOldVehicleCost}
      setNewVehicleCost={setNewVehicleCost}
      /> */}

      {/* {showVehicleSlider && (
        <NewUICustomSliderForSinglePackage
          onClose={() => setShowVehicleSlider(false)}
          setIsSliderOpen={setShowVehicleSlider}
          allVehicles={allVehicles}
          fetchTransportCost={fetchTransportCost}
          fetchCostOfVehicle={fetchCostOfVehicle}
          vehicleDetails={vehicleDetails}
          setOldVehicleCost={setOldVehicleCost}
          setNewVehicleCost={setNewVehicleCost}
        />
      )} */}

      <section className={styles.sm_footer}>
        <NewFooterUI />
      </section>
    </>
  );
};

export default NewUiSinglePackage;
